import React, { Component } from 'react';
import {
    NavBar, BreadCumb, TimeOut, CollectModal, PartnerCreateModal, PaymentModal,
    InitialCashModal, GeneralFunctions, PdfViewer, CashCutModal, CancelCFDI, CancelPaymentModal,
    PaymentStatusListModal, ValidationModal,
    DataTables,
    CollectDeposits
} from '../../components';
import { Datos_Empresa, development, ImageVoucherMIT_dev, ImageVoucherMIT_prod, Modules, points_Card, needTransferReference, Sections } from "../../libs/utils/Const";
import { DISPATCH_ID, SERVICE_RESPONSE, CURRENCY } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import config from '../../config';
import '../../css/tablesPOS.css';
import { ApiClient } from "../../libs/apiClient";
import $ from "jquery";
import moment from "moment";
import {
    NewOrderSales,
    NewItemCheck,
    NewOrder,
    NewItemPayment,
    CreditCards,
    PayMethodCounter,
    PaymentCardsInfo
} from "../../components/NewOrder";
import packageJson from '../../../package.json';
import socketService from '../../libs/sockets/SocketService';
import FactoryActions from '../../components/FactoryActions/FactoryActions';
import FactoryHeader from '../../components/FactoryHeader/FactoryHeader';
import FactoryBody from '../../components/FactoryBody/FactoryBody';
import VoucherUploadModal from '../../components/paymentMethods/uploadVoucher';
import { roundToDecimals } from '../../libs/utils/GlobalFunc';
import Select from 'react-select';
let apiClient = ApiClient.getInstance();
let _generalFunctions = new GeneralFunctions();

global.appVersion = packageJson.version;
const currentVersion = global.appVersion;

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol, decimals = 2) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(decimals));
    },
};

let headers = [
    { title: '', value: true },
    { title: 'Tipo', value: true },
    { title: 'Número', value: true },
    { title: 'No.Ref.de. cliente', value: true },
    { title: 'Cliente', value: true },
    { title: 'Nombre', value: true },
    { title: 'Fecha', value: true },
    { title: 'Venció', value: true },
    { title: 'Total', value: true },
    { title: 'Abonado', value: true },
    { title: 'Por pagar', value: true },
    { title: 'Nro. Pagos', value: true },
];

class CollectView extends Component {

    constructor(props) {
        super(props);
        this.dataTablesRef = React.createRef();
        this.state = {
            folio: '',
            cliente: '',
            dataInvoice: [],
            showCollectModalModal: false,
            checkboxDataTables: (new Map()),
            partners: [],
            pageTotal: 0,
            total: 0,
            ModelCollect: new NewOrderSales(),
            series: [],
            ShowOpenSeriesModal: false,
            accounts: [],
            ShowAccountsModal: false,
            accountMayorId: 0,
            ShowPaymentModal: false,
            checkItemCreateInfo: {
                banks: [],
                contries: [],
            },
            ShowCheckListModal: false,
            newOrderModel: [],
            showPaymentModal: false,
            showAreYouAgreeModal: false,
            ShowPaymentCreditCardsModal: false,
            cardList: [],

            accountsCredit: [],
            ShowAccountsModalCredit: false,
            cardId: 0,
            showBillModal: false,
            PaymentSaleModel: new PayMethodCounter(),
            addingPay: true,
            AvailablePayments: [],
            BankAccounts: [],
            DownPayments: [],
            CreditNotes: [],
            idWorkShift: "",
            showInitialCashModal: false,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            docsToPrint: [],
            showPDFViewer: false,
            EnableEditButton: false,
            EditableDocModel: {
                street: '',
                county: '',
                city: '',
                block: '',
                zipCode: '',
                rfc: '',
                shipStreet: '',
                shipCounty: '',
                shipCity: '',
                shipBlock: '',
                shipZipCode: ''
            },

            showCashCutModal: false,
            lastDaySession: false,
            cashCut: {},
            objCharge: {},
            extraPaymentsCashCut: {},
            totalCashCut: 0,
            TotalAmountSales: 0,
            numSalesCashCut: 0,
            moneyEntries: [],
            moneyOuts: [],
            writeAccess: false,
            printhide: true,
            CancelFunction: null,
            ReturnedBlindCut: [],
            auxCacheEntry: null,
            TODAY: moment(new Date()).format('YYYY-MM-DD'),
            taxCodeSearch: 0,

            PaymentStatus: [],

            // Cancelar con fecha actual
            cancelCurrentDate: false,
            FlagPayWithSantander: false,

            // OXXO REFERENCES
            OxxoReference: '',
            searchData: {
                dateFrom: moment(new Date()).format('YYYY-MM-DD'),
                dateTo: moment(new Date()).format('YYYY-MM-DD'),
            },
            listDrivers: [],
            showCollectDeposits: false,
            dateInit: moment().format('YYYY-MM-DD'),
            dateFinal: moment().format('YYYY-MM-DD'),
            globalCurrency: '',
            allSN: false,
            showNiubizModal: false,
            currPayment: new PayMethodCounter(),
            seriesOptions: [],
            selectedSeries: [],
            transportSeriesOptions: [],
            selectedTransportSeries: [],
            isNewSearch: true,
            multiplePaymentsSummary: [],
            multiplePerceptions: [],
            isSameSerie: false,
            perceptionsConfirmed: false,
            modelsByClientPending: [],
            voucher: null,
            bankOptions: [],
            //#region Flujo de caja
            CFWOptions: [],
            //#endregion Flujo de caja
            toleranceInfo: [],
            tipoFactura: '',
            currencys: [],
        }
    }

    componentDidMount = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { ModelCollect, TODAY } = this.state;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let newArraySeries = [];
        let seriesUsers = user.U_FMB_ValidateSeriesORCT.split("|");
        let dataSerie = {
            docType: '24',
            docSubType: '--'
        };
        this._handelBack();
        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);
        if (!seriesResponse.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: "Error inesperado al consultar las series de su sucursal para cobranza. Contacte con su administrador y recargue la pagina" });
            return;
        }
        seriesUsers.map(serieUser => {
            seriesResponse.data.map(serieResponse => {
                if (String(serieResponse.Series) === String(serieUser)) {
                    newArraySeries.push(serieResponse);
                }
            })
        })

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }
        this.GetBankAccounts();
        await this.GetCurrencies();
        await this.CheckWorkSession();
        ModelCollect.SerieArray = newArraySeries;

        let PaymentMethods = [];
        if (user.Branch.PaymentMethods) {
            for (let index = 0; index < user.Branch.PaymentMethods.length; index++) {
                const element = user.Branch.PaymentMethods[index];
                if (Number(element.type) !== 4 && (Number(element.TipoUso) === 2 || Number(element.TipoUso) === 3)) {
                    PaymentMethods.push(element);
                }
            }
        }

        //#region Flujo de caja
        let accounts = '';
        let accountRes = [];
        let CFWOptions = [];
        if (Sections['FlujoCaja'] && PaymentMethods?.length) {
            enableSpinner(true);
            CFWOptions = await apiClient.getOCFW();
            CFWOptions = CFWOptions?.data ?? [];
            enableSpinner(false);

            accounts = [...new Set(
                PaymentMethods
                    ?.map(item => item?.AcctCode)
                    ?.filter(Boolean)
            )]
                ?.map(account => `''${account}''`)
                ?.join(', ');

            enableSpinner(true);
            accountRes = await apiClient.accountInfo({ accounts });
            enableSpinner(false);
            if (accountRes?.status) {
                accountRes = accountRes?.data ?? [];

                for (const element of PaymentMethods) {
                    const accountInfo = accountRes?.find(row => row.AcctCode === element.AcctCode);
                    if (accountInfo?.AcctCode) {
                        element.CfwRlvnt = accountInfo?.CfwRlvnt || null;
                        element.Finanse = accountInfo?.Finanse || null;

                        const needCFW = element.CfwRlvnt === 'Y' && element.Finanse === 'Y';
                        switch (Number(element.type)) {
                            case 0:
                                element.cashCFWId = null; // Para efectivo
                                element.needCashCFW = needCFW; // Para efectivo
                                element.cashCFWOptions = CFWOptions ?? []; // Para efectivo
                                break;
                            case 1:
                                element.checkCFWId = null; // Para cheques
                                element.needCheckCFW = needCFW; // Para cheques
                                element.checkCFWOptions = CFWOptions ?? []; // Para cheques
                                break;
                            case 3:
                                element.transferCFWId = null; // Para transferencias
                                element.needTransferCFW = needCFW; // Para transferencias
                                element.transferCFWOptions = CFWOptions ?? []; // Para transferencias
                                break;
                            default:
                                element.transferCFWId = null; // Para transferencias
                                element.needTransferCFW = false; // Para transferencias
                                element.transferCFWOptions = []; // Para transferencias

                                element.cashCFWId = null; // Para efectivo
                                element.needCashCFW = false; // Para efectivo
                                element.cashCFWOptions = []; // Para efectivo

                                element.checkCFWId = null; // Para cheques
                                element.needCheckCFW = false; // Para cheques
                                element.checkCFWOptions = []; // Para cheques
                                break;
                        }
                    }
                }
            }
        }
        //#endregion Flujo de caja
        PaymentMethods.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));

        ///permisions
        const modules = user.U_FMB_Modulos ? JSON.parse(user.U_FMB_Modulos) : null
        let writeAccess = false;
        if (modules.payments) {
            writeAccess = modules.payments.Wr
        }
        await this.setState({
            ModelCollect,
            series: newArraySeries,
            LimitLinesBO: user.Branch.LimitLines || null,
            CounterRol: user.U_FMB_CounterRol || null,
            AvailablePayments: PaymentMethods || [],
            writeAccess,
            globalCurrency: CURRENCY,
            CFWOptions
        });

        if (TODAY.valueOf() <= '2023-07-20') {
            showAlert({ type: 'info', message: 'HOLA USUARIO, CON ESTA NUEVA ACTUALIZACIÓN NO PUEDES CREAR UN DOCUMENTO DE COBRANZA CON DISTINTOS METODOS DE PAGO, OSEASE QUE NO PUEDES MEZCLAR DOCUMENTOS TIPO PPD Y PUE. AL IGUAL NO PUEDES MEZCLAR DOCUMENTOS DE 16% CON 8% (CLICK PARA DESAPARECER ESTE AVISO)', timeOut: 90000 });
        }
        this.DeterminatePayWithTerminalPermission();

        enableSpinner(true);
        let transportSeriesResponse = await apiClient.getTransportSeries();
        enableSpinner(false);
        if (!transportSeriesResponse?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: transportSeriesResponse?.message || "Ocurrió un error al obtener las series de los transportes" });
        } else {
            this.setState({
                transportSeriesOptions: transportSeriesResponse?.data ?? []
            })
        }

        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }

        enableSpinner(true);
        let toleranceRes = await apiClient.getToleranceInfo();
        enableSpinner(false);
        if (!toleranceRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: toleranceRes?.message || "Ocurrió un error al obtener la información de tolerancias permitidas" });
        } else {
            this.setState({
                toleranceInfo: toleranceRes?.data ?? []
            })
        }
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            if (tableReg.rows[i].classList.contains("noSearch")) {
                continue;
            }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length === 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText === "") {
            lastTR.classList.add("hide");
        } else if (total) {
            td.innerHTML = "Se ha encontrado " + total + " coincidencia" + ((total > 1) ? "s" : "");
        } else {
            lastTR.classList.add("red");
            td.innerHTML = "No se han encontrado coincidencias";
        }
    }

    CargarDatos = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { folio, cliente, OxxoReference, dateInit, dateFinal, tipoFactura, allSN = false, selectedSeries = [], selectedTransportSeries = [] } = this.state;
        let isNewSearch = !selectedSeries?.length && !selectedTransportSeries?.length;

        if (!allSN && cliente === '' && OxxoReference === '') {
            showAlert({ type: 'warning', message: 'Escribe el código de un cliente' });
            return;
        }
        const datos = {
            folio,
            cliente,
            OxxoReference,
            dateInit,
            dateFinal,
            tipoFactura,
            allSN,
        }

        enableSpinner(true);
        const Invoices = await apiClient.getInvoices(datos);
        enableSpinner(false);

        if (Invoices.status === SERVICE_RESPONSE.SUCCESS) {

            if (!Array.isArray(Invoices.data)) {
                showAlert({ type: 'info', message: Invoices.message, timeOut: 5000 });
                return;
            }

            if (Invoices.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                this.setState({
                    dataInvoice: [],
                    checkboxDataTables: (new Map()),
                });
                return;
            }

            await this.GetDownPaymentsByPartner(cliente);
            //#region ################## POINTS CARD ################ ✔
            if (points_Card) {
                let search = {
                    CardCode: cliente,
                }
                await this.searchPointsCard(search);
            }
            //#endregion ################## POINTS CARD ################ ✔
            for (const invoice of Invoices?.data) {
                invoice.DocCur = invoice.DocCur || CURRENCY;
                if (invoice.DocCur !== CURRENCY) {
                    invoice.PorVencer = invoice?.PorVencerFC;
                    invoice.totalPago = invoice?.totalPagoFC;
                    invoice.PrcntTax = invoice?.PrcntTaxFC;
                }
            }

            let dataSerie = {
                docType: "13",
                docSubType: "--"
            };
            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user?.U_FMB_ValidateSeriesOINV ?? "";
            let ValidateSeriesODPI = user?.U_FMB_ValidateSeriesODPI ?? "";
            let ValidateSeriesSUNAT = user?.U_FMB_ValidateSeriesSUNAT ?? "";
            let ValidateSeriesPUERTA = user?.U_FMB_ValidateSeriesPUERTA ?? "";
            const branchType = user?.Branch?.Type;

            if (!user || (!ValidateSeries && !ValidateSeriesODPI)) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    dataInvoice: [],
                    dataInvoiceCopy: [],
                    checkboxDataTables: (new Map()),
                    seriesOptions: [],
                    isNewSearch: true,
                    multiplePaymentsSummary: [],
                    multiplePerceptions: [],
                    isSameSerie: false,
                    perceptionsConfirmed: false,
                    modelsByClientPending: [],
                }, () => {
                    if (this.dataTablesRef.current) {
                        this.dataTablesRef.current.resetCheckboxes();
                    }
                });
                return;
            }

            let seriesUsers = ValidateSeries?.split("|");
            let seriesUsersODPI = ValidateSeriesODPI?.split("|");

            const cleanSeries = (input) => {
                const result = [];

                if (!input) return result;

                if (typeof input === 'string') {
                    return input
                        .split('|')
                        .filter(v => v)
                        .map(v => v.replace('~D', ''));
                }

                if (typeof input === 'object') {
                    for (const key in input) {
                        const value = input[key];

                        if (typeof value === 'string') {
                            const parts = value.split('|');

                            for (let i = 0; i < parts.length; i++) {
                                const val = parts[i];
                                if (val) {
                                    result.push(val.replace('~D', ''));
                                }
                            }
                        }
                    }
                }

                return result;
            };

            const seriesSUNAT = cleanSeries(ValidateSeriesSUNAT);
            const seriesPUERTA = cleanSeries(ValidateSeriesPUERTA);
            const mergedSeries = [...seriesSUNAT, ...seriesPUERTA];

            const uniqueSeries = [];
            for (let i = 0; i < mergedSeries.length; i++) {
                const val = mergedSeries[i];
                if (val && uniqueSeries.indexOf(val) === -1) {
                    uniqueSeries.push(val);
                }
            }

            let newArraySeries = [];
            let newArraySeriesOINV = [];
            let newArraySeriesODPI = [];
            for (let i = 0; i < seriesUsers.length; i++) {
                const serieUser = seriesUsers[i];

                for (let j = 0; j < seriesResponse.data.length; j++) {
                    const serieResponse = seriesResponse.data[j];

                    if (
                        String(serieResponse.Series) === String(serieUser) &&
                        Number(serieResponse.ObjectCode) === 13 &&
                        serieResponse.DocSubType === '--'
                    ) {
                        // newArraySeries.push(serieResponse);
                        newArraySeriesOINV.push(serieResponse);
                    }
                }
            }
            for (let i = 0; i < seriesUsersODPI.length; i++) {
                const serieUser = seriesUsersODPI[i];

                for (let j = 0; j < seriesResponse.data.length; j++) {
                    const serieResponse = seriesResponse.data[j];

                    if (
                        String(serieResponse.Series) === String(serieUser) &&
                        Number(serieResponse.ObjectCode) === 203
                    ) {
                        newArraySeriesODPI.push(serieResponse);
                    }
                }
            }

            newArraySeries = newArraySeries.concat(
                newArraySeriesOINV?.length ? newArraySeriesOINV : [],
                newArraySeriesODPI?.length ? newArraySeriesODPI : []
            );

            if (!newArraySeries || newArraySeries?.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida"
                });

                this.setState({
                    dataInvoice: [],
                    dataInvoiceCopy: [],
                    checkboxDataTables: (new Map()),
                    seriesOptions: [],
                    isNewSearch: true,
                    multiplePaymentsSummary: [],
                    multiplePerceptions: [],
                    isSameSerie: false,
                    perceptionsConfirmed: false,
                    modelsByClientPending: [],
                }, () => {
                    if (this.dataTablesRef.current) {
                        this.dataTablesRef.current.resetCheckboxes();
                    }
                });
                return;
            }

            // (Series + SUNAT/PUERTA)
            let newDocumentsfilterSeries = [];
            let seriesSet = new Set();
            let seriesOptions = [];

            const selectedSeriesValues = (selectedSeries || []).map(s => String(s.value));
            const selectedTransportSeriesValues = (selectedTransportSeries || []).map(s => String(s.value));

            for (let i = 0; i < (Invoices.data?.length || 0); i++) {
                const document = Invoices.data[i];

                for (let j = 0; j < newArraySeries.length; j++) {
                    const serie = newArraySeries[j];

                    const matchSerie = String(document.SeriesCode) === String(serie.Series) && (Number(document?.ObjType) === 203 ? Number(document?.ObjType) === Number(serie?.ObjectCode) : true);

                    if (matchSerie || Number(branchType) === 3) {
                        if (document.NumAtCard) {
                            if (isNewSearch) { // Obtener series a partir de resultados
                                const extracted = this.extractSerie(document.NumAtCard);

                                if (extracted && !seriesSet.has(extracted)) {
                                    seriesSet.add(extracted);

                                    seriesOptions.push({
                                        value: extracted,
                                        label: extracted
                                    });
                                }

                                newDocumentsfilterSeries.push(document);
                                break;

                            } else { // Filtro por series seleccionadas
                                const extracted = this.extractSerie(document.NumAtCard);
                                const allSelectedSeries = [...selectedSeriesValues, ...selectedTransportSeriesValues];
                                if (allSelectedSeries.length === 0) {
                                    newDocumentsfilterSeries.push(document);
                                    break;
                                }

                                if (extracted && allSelectedSeries.includes(String(extracted))) {
                                    newDocumentsfilterSeries.push(document);
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            if (!newDocumentsfilterSeries || newDocumentsfilterSeries?.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "No hay Información por mostrar"
                });

                this.setState({
                    dataInvoice: [],
                    dataInvoiceCopy: [],
                    checkboxDataTables: (new Map()),
                    seriesOptions: [],
                    isNewSearch: true,
                    multiplePaymentsSummary: [],
                    multiplePerceptions: [],
                    isSameSerie: false,
                    perceptionsConfirmed: false,
                    modelsByClientPending: [],
                }, () => {
                    if (this.dataTablesRef.current) {
                        this.dataTablesRef.current.resetCheckboxes();
                    }
                });
                return;
            }

            let sortedSeriesOptions = seriesOptions;
            if (isNewSearch) {
                sortedSeriesOptions = [...seriesOptions].sort((a, b) =>
                    a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })
                );
            }

            this.setState((prevState) => ({
                dataInvoice: newDocumentsfilterSeries ?? [],
                dataInvoiceCopy: newDocumentsfilterSeries ?? [],
                checkboxDataTables: new Map(),
                seriesOptions: isNewSearch ? sortedSeriesOptions : prevState.seriesOptions,
                isNewSearch,
                multiplePaymentsSummary: [],
                multiplePerceptions: [],
                isSameSerie: false,
                perceptionsConfirmed: false,
                modelsByClientPending: [],
            }), () => {
                if (this.dataTablesRef.current) {
                    this.dataTablesRef.current.resetCheckboxes();
                }
            });

            if (Invoices.data.length === 0) {
                this.setState({
                    dataInvoice: [],
                    dataInvoiceCopy: [],
                    checkboxDataTables: (new Map()),
                    seriesOptions: [],
                    isNewSearch: true,
                    multiplePaymentsSummary: [],
                    multiplePerceptions: [],
                    isSameSerie: false,
                    perceptionsConfirmed: false,
                    modelsByClientPending: [],
                }, () => {
                    if (this.dataTablesRef.current) {
                        this.dataTablesRef.current.resetCheckboxes();
                    }
                });
            }
            return;

        }
        showAlert({ type: 'error', message: Invoices.message });
    }

    ShowCollectModalModal = async (action = null, checkboxDataTables) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { dataInvoice, ModelCollect, series, allSN } = this.state;
        if (action === 1) {
            let docEntryArray = [];

            for (let [id, value] of checkboxDataTables.entries()) {
                if (value) {
                    docEntryArray.push(dataInvoice[id]);
                }
            }

            if (docEntryArray.length === 0) {
                showAlert({ type: 'warning', message: "Seleccione un documento" });
                return;
            }

            if (docEntryArray?.some(doc => doc.DocCur !== docEntryArray?.[0]?.DocCur)) {
                showAlert({ type: 'warning', message: "Todos los documentos seleccionados deben de tener la misma moneda" });
                return;
            }

            if (!allSN) {
                if (docEntryArray?.some(doc => doc.CardCode !== docEntryArray?.[0]?.CardCode)) {
                    showAlert({ type: 'warning', message: "Todos los documentos seleccionados deben de pertenecer al mismo cliente" });
                    return;
                }
            }

            let total = 0;

            //#region CREDIT PERCEPTIONS
            let perceptionData = [...docEntryArray];

            enableSpinner(true);

            let checkPerceptions;
            try {
                showAlert({ type: 'info', message: 'Revisando percepciones, por favor espere.' });
                checkPerceptions = await apiClient.perceptionJournalEntries(perceptionData);
            } catch (error) {
                showAlert({ type: 'error', message: 'Error al validar percepciones' });
                enableSpinner(false);
                return;
            }

            enableSpinner(false);

            if (!checkPerceptions?.status) {
                showAlert({ type: 'error', message: 'Ocurrió un error al validar las percepciones' });
                return;
            }

            const validPerceptionJE = [];

            for (const line of (checkPerceptions?.data ?? [])) {
                if (line?.TransIdError || line?.creditPerceptionError) {
                    const { DocNum } = line ?? {};
                    showAlert({
                        type: 'error',
                        message: `Ocurrió un error al validar las percepciones de la factura ${DocNum ?? ''}`,
                        timeOut: 8000
                    });
                } else {
                    validPerceptionJE.push(line);
                }
            }

            docEntryArray = validPerceptionJE;
            //#endregion CREDIT PERCEPTIONS

            //#region CESION USO CONTADO
            enableSpinner(true);
            let validateCUSO = await apiClient.validateCUso({ Documents: docEntryArray });
            enableSpinner(false);
            //#endregion CESION USO CONTADO
            if (validateCUSO.status == 1) {
                docEntryArray = validateCUSO?.data ?? docEntryArray
            }

            const newItemsPayments = docEntryArray.map(element => {
                const totalPago = Number(element?.totalPago ?? 0).toFixed(2);
                const U_PRC_IMP = Number(element?.U_PRC_IMP ?? 0);
                const originalU_PRC_IMP = Number(element?.originalU_PRC_IMP ?? 0);
                const U_STR_FE_Tasa_Percepcion = Number(element?.U_STR_FE_Tasa_Percepcion ?? 0);
                const auxOriginalU_PRC_IMP = Number(element?.auxOriginalU_PRC_IMP ?? 0);
                const auxU_STR_FE_Tasa_Percepcion = Number(element?.auxU_STR_FE_Tasa_Percepcion ?? 0);
                const auxU_PRC_IMP = Number(element?.auxU_PRC_IMP ?? 0);;
                const PorVencer = Number(element?.PorVencer ?? 0);

                total += PorVencer;

                return {
                    ...element,
                    totalPago,
                    U_Parcialidad: '1',
                    U_PRC_IMP, // Importe a pagar de la percepción
                    originalU_PRC_IMP, // Valor total de la percepción
                    auxU_PRC_IMP, // Total restante a pagar de la percepción
                    U_STR_FE_Tasa_Percepcion, // % de percepción grabado - Determinado por calculo
                    auxOriginalU_PRC_IMP, // Total original de la percepción - En pagos - Grabado en el documento
                    auxU_STR_FE_Tasa_Percepcion, // % de percepción grabado - Grabado en el documento
                };
            });

            let defaultName = "";
            let defaultcode = "";
            let nextNumber = "";

            if (series.length === 1) {
                const serie = series[0];
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber;
            }

            let newModelCollect = {
                ...ModelCollect,
                SerieName: defaultName,
                SerieCode: defaultcode,
                NextFolio: nextNumber,
                ItemsPayments: newItemsPayments,
                DocCur: CURRENCY,
                ChangeRate: 1,
                ifChangeRate: false,
                ChangeRate_1: 1,
                PaymentsToSale: [],
                TotalRecibido: 0,
                TotalRestante: 0,
                total,
                U_BPP_MDTDPaymentDefault: '',
                U_BPP_PTSCPaymentDefault: ''
            };

            if (!allSN) {
                newModelCollect.CardCode = newModelCollect.ItemsPayments?.[0]?.CardCode;
                newModelCollect.CardName = newModelCollect.ItemsPayments?.[0]?.CardName;
            }
            const cardCodes = [
                ...new Map(
                    docEntryArray.map(doc => [doc.CardCode, { CardCode: doc.CardCode }])
                ).values()
            ];
            enableSpinner(true)
            await this.GetDownPaymentsByPartner(null, cardCodes)
            enableSpinner(false)


            this.setState(
                {
                    ModelCollect: newModelCollect,
                    showCollectModalModal: true,
                    PaymentSaleModel: new PayMethodCounter(),
                    addingPay: false
                },
                () => {
                    $("#collectModal").modal("show");
                }
            );

            return;
        }

        $("#collectModal").modal("hide");
        this.setState({
            showCollectModalModal: false,
            multiplePaymentsSummary: [],
            multiplePerceptions: [],
            isSameSerie: false,
            perceptionsConfirmed: false,
            modelsByClientPending: [],
        })
    };

    ChangeFolio = event => {
        let valor = event.nativeEvent.target.value;
        this.setState({
            folio: valor
        });
    };

    ChangeCliente = event => {
        let valor = event.nativeEvent.target.value;
        this.setState({
            cliente: valor
        });
    };

    MapFind(map, callback) {
        for (const [key, value] of map) {
            if (callback(value, key, map)) {
                return value;
            }
        }
        return undefined;
    }

    toggleDocumentSelected = async (id) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { dataInvoice, auxCacheEntry } = this.state

        if (auxCacheEntry !== null) {
            const actualEntry = dataInvoice[id];
            if (auxCacheEntry.U_SO1_02METODOPAGO !== actualEntry.U_SO1_02METODOPAGO) {
                showAlert({ type: 'info', message: `SOLO PUEDES SELECCIONAR FACTURAS DE UN TIPO, LA ANTERIOR SELECCIONADA ES DE TIPO: ${auxCacheEntry.U_SO1_02METODOPAGO} Y LA QUE QUERÍA SELECCIONAR ES DE TIPO ${actualEntry.U_SO1_02METODOPAGO}`, timeOut: 6500 });
                return;
            }
            if ((auxCacheEntry.U_FMB_RelatedFolio || "").slice(3, 5) !== (actualEntry.U_FMB_RelatedFolio || "").slice(3, 5)) {
                if ((actualEntry.U_FMB_RelatedFolio || "").slice(3, 5) === "CP") return showAlert({ type: 'info', message: `SOLO PUEDES SELECCIONAR FACTURAS DE UN TIPO, LA QUE QUERÍA SELECCIONAR ES DE TIPO FLETE PARA CARTA PORTE`, timeOut: 6500 });
                else return showAlert({ type: 'info', message: `SOLO PUEDES SELECCIONAR FACTURAS DE UN TIPO, LA ANTERIOR SELECCIONADA ES DE TIPO FLETE PARA CARTA PORTE`, timeOut: 6500 });
            }
            // if (Number(auxCacheEntry.PrcntTax) !== Number(actualEntry.PrcntTax)){
            //     showAlert({ type: 'info', message: `SOLO PUEDES SELECCIONAR FACTURAS DE UN TIPO DE IMPUESTO, LA ANTERIOR SELECCIONADA ES DE: ${auxCacheEntry.PrcntTax} % Y LA QUE QUERÍA SELECCIONAR ES DE TIPO ${actualEntry.PrcntTax} % `, timeOut: 6500 });
            //     return; 
            // }
        }

        await this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id));
            return { checkboxDataTables };
        });

        const result = this.MapFind(this.state.checkboxDataTables, (value, key, map) => {
            return value === true; // Custom condition to find 'value2'
        });

        if (result === undefined) {
            await this.setState({
                auxCacheEntry: null
            })
        } else {
            await this.setState({
                auxCacheEntry: dataInvoice[id]
            })

        }



    };

    toggleDocumentSelectedAll = (action) => {
        const { dataInvoice } = this.state;
        let newCheckbox = (new Map());

        for (let index = 0; index < dataInvoice.length; index++) {
            const register = dataInvoice[index];

            if (register.statusBorrador !== 'W') {
                newCheckbox.set(index, action)
            }
        }

        this.setState({
            checkboxDataTables: newCheckbox
        });
    };

    openPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartner('C', null);
        enableSpinner(false);

        if (getPartnerResponse.status === 0) {
            if (!Array.isArray(getPartnerResponse.data.results)) {
                showAlert({ type: 'info', message: getPartnerResponse.message });
                return;
            }
            if (getPartnerResponse.data.results.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }
        this.setState({
            partners: getPartnerResponse.data.results ? getPartnerResponse.data.results : getPartnerResponse.data,
            pageTotal: getPartnerResponse.data.totalPage || 1,
        });
        $('#partnerCreate').modal('show');

    };

    SelectPartner = async action => {
        const { partners, ModelCollect } = this.state;
        let partner = partners[action.index];

        ModelCollect.CardCode = partner.CardCode;
        ModelCollect.CardName = partner.CardName;
        ModelCollect.U_FMB_AUX_CARDNAME = partner.U_FMB_AUX_CARDNAME;

        ModelCollect.BpAct = partner.AcctCode || '';
        ModelCollect.BpActName = partner.AcctName || '';
        ModelCollect.BpActFormatCode = partner.FormatCode || partner.BpActFormatCode;
        ModelCollect.BpActCopy = partner.AcctCode || '';
        ModelCollect.BpActNameCopy = partner.AcctName || '';
        ModelCollect.BpActFormatCodeCopy = partner.FormatCode || '';
        ModelCollect.Address = partner.Address || '';
        await this.setState({
            cliente: partner.CardCode,
            ModelCollect,
            allSN: false,
        })
        await this.CargarDatos();
        $('#partnerCreate').modal('hide');
    }

    RefreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    }

    ChangeTotalInvoicePayment = async (event, index) => {
        const { ModelCollect } = this.state;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data !== ' ') {
                ModelCollect.ItemsPayments[index].totalPago = event.nativeEvent.target.value;
            }
        }
        await this.setState({
            ModelCollect
        });
    };

    ChangeParcialidadInvoicePayment = async (event, index) => {
        const { ModelCollect } = this.state;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data !== ' ') {
                ModelCollect.ItemsPayments[index].U_Parcialidad = event.nativeEvent.target.value;
            }
        }
        await this.setState({
            ModelCollect
        });
    };

    ValidateTotalInvoicePaymentNullORIGINAL = async index => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        let value = ModelCollect.ItemsPayments[index].totalPago;

        if (value.length === 0) {
            ModelCollect.ItemsPayments[index].totalPago = ModelCollect.ItemsPayments[index].PorVencer;
        }

        if (Number(value) > Number(ModelCollect.ItemsPayments[index].PorVencer)) {
            showAlert({ type: 'info', message: 'El valor ingresado es mayor que el saldo vencido' });
            ModelCollect.ItemsPayments[index].totalPago = ModelCollect.ItemsPayments[index].PorVencer;
        }
        await this.setState({
            ModelCollect
        });
    };

    ValidateTotalInvoicePaymentNull = async index => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;

        const items = [...ModelCollect.ItemsPayments];
        const item = { ...items[index] };

        let value = item.totalPago;
        let flagPerception = false;

        if (!value || value?.length === 0) {
            item.totalPago = item.PorVencer;
            item.U_PRC_IMP = item.auxU_PRC_IMP;
            flagPerception = true;
        }

        if (Number(value) > Number(item.PorVencer)) {
            showAlert({ type: 'info', message: 'El valor ingresado es mayor que el saldo vencido' });
            item.totalPago = item.PorVencer;
            item.U_PRC_IMP = item.auxU_PRC_IMP;
            flagPerception = true;
        }

        if (Number(value) < 0) {
            showAlert({ type: 'info', message: 'El valor ingresado no puede ser negativo' });
            item.totalPago = item.PorVencer;
            item.U_PRC_IMP = item.auxU_PRC_IMP;
            flagPerception = true;
        }

        //#region CREDIT PERCEPTIONS
        if (!flagPerception && Number(item.originalU_PRC_IMP) > 0) {
            if (Number(value) === Number(item.PorVencer)) {
                item.U_PRC_IMP = item.auxU_PRC_IMP;
            } else {
                const porcentaje = Number(value) === 0 ? 0 : Number(value) / Number(item.PorVencer);
                // item.U_PRC_IMP = roundToDecimals((Number(item.auxU_PRC_IMP) || 0) * porcentaje, 6);
                item.U_PRC_IMP = roundToDecimals((Number(item.auxU_PRC_IMP) || 0) * porcentaje, 2);
            }
        }
        //#endregion CREDIT PERCEPTIONS

        items[index] = item;

        await this.setState({
            ModelCollect: {
                ...ModelCollect,
                ItemsPayments: items
            }
        });
    };

    SelectDocDate = async event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        const docDate = event.nativeEvent.target.value;
        if (!moment(docDate, 'YYYY-MM-DD', true).isValid()) return;
        if (docDate !== ModelCollect.DocDate && ModelCollect.PaymentsToSale?.length) {
            showAlert({ type: 'warning', message: 'Retira los pagos agregados antes de cambiar la fecha de contabilización para actualizar el tipo de cambio.' });
            return;
        }
        let today = moment(new Date()).format('YYYY-MM-DD');
        if (event.nativeEvent.target.value > today) {
            showAlert({
                type: 'error',
                message: 'La fecha de contabilización tiene que ser igual o menor al día actual',
            });
            return;
        }
        ModelCollect.DocDate = docDate;
        ModelCollect.TaxDate = docDate;
        await this.setState({
            ModelCollect
        });
        await this.GetCurrencies(docDate);
    };

    SelectDocDueDate = async event => {
        const { ModelCollect } = this.state;
        ModelCollect.DocDueDate = event.nativeEvent.target.value;
        await this.setState({
            ModelCollect
        });
    };

    SelectU_BPP_PTSCPaymentDefault = async (value = '') => {
        value = value?.slice(0, 4);
        const { ModelCollect } = this.state;
        ModelCollect.U_BPP_PTSCPaymentDefault = value;
        await this.setState({
            ModelCollect
        });
    };

    OpenSeries = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        if (ModelCollect.SerieArray.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        setTimeout(() => {
            this.setState({
                series: ModelCollect.SerieArray,
                ShowOpenSeriesModal: !this.state.ShowOpenSeriesModal
            });
            $('#seriesDocumentsModal').modal('show');
        }, 100);
    };

    SelectSeries = action => {
        const { ModelCollect } = this.state;
        let serie = ModelCollect.SerieArray[action.index];
        ModelCollect.SerieName = serie.SeriesName || '';
        ModelCollect.SerieCode = serie.Series || '';
        ModelCollect.NextFolio = serie.NextNumber || '';
        ModelCollect.Series = serie.Series || '';
        $('#seriesDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                ModelCollect,
                series: [],
                ShowOpenSeriesModal: false,//!this.state.ShowOpenSeriesModal
            });
        }, 100);
    };

    OpenCuentaMayor = async (index = null, cuenta) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        enableSpinner(true);
        let response = await apiClient.getCuentaMayor();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accounts: response.data,
            accountMayorId: cuenta,
            ShowAccountsModal: !this.state.ShowAccountsModal,
        });

        $('#AccountListModal').modal('show');
    };

    SelectAccountList = action => {
        const { accounts, accountMayorId, ModelCollect } = this.state;
        let account = accounts[action.index];

        if (accountMayorId === 2) {
            ModelCollect.TrsfrAcct = account.AcctCode || '';
            ModelCollect.TrsfrAcctName = account.AcctName || '';
            ModelCollect.TrsfrAcctFormatCode = account.FormatCode || '';
        }

        if (accountMayorId === 3) {
            ModelCollect.CheckAcct = account.AcctCode || '';
            ModelCollect.CheckAcctName = account.AcctName || '';
            ModelCollect.CheckAcctFormatCode = account.FormatCode || '';
        }

        if (accountMayorId === 4) {
            ModelCollect.CashAcct = account.AcctCode || '';
            ModelCollect.CashAcctName = account.AcctName || '';
            ModelCollect.CashAcctFormatCode = account.FormatCode || '';
        }

        $('#AccountListModal').modal('hide');

        setTimeout(() => {
            this.setState({
                ModelCollect,
                account: [],
                ShowAccountsModal: false,
            });
        }, 100);
    };

    changeCashSumEnter = event => {
        const { ModelCollect } = this.state;
        if (!isNaN(ModelCollect.totalPago)) {
            if (ModelCollect.totalPago !== ' ') {
                ModelCollect.CashSum = ModelCollect.totalPago;
            }
        }

        setTimeout(() => {
            this.setState({
                ModelCollect
            });
        }, 100);
    };

    changeCashSum = event => {
        const { ModelCollect } = this.state;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data !== ' ') {
                ModelCollect.CashSum = event.nativeEvent.target.value;
            }
        }
        setTimeout(() => {
            this.setState({
                ModelCollect
            });
        }, 100);
    };

    validateCashSumNull = index => {
        const { ModelCollect } = this.state;
        let value = ModelCollect.CashSum;

        if (value.length === 0) {
            ModelCollect.CashSum = 0;
        }
        setTimeout(() => {
            this.setState({
                ModelCollect
            });
        }, 100);
    };

    changeTrsfrSum = event => {
        const { ModelCollect } = this.state;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data !== ' ') {
                ModelCollect.TrsfrSum = event.nativeEvent.target.value;
            }
        }
        setTimeout(() => {
            this.setState({
                ModelCollect
            });
        }, 100);
    };

    validateTrsfrSumNull = index => {
        const { ModelCollect } = this.state;
        let value = ModelCollect.TrsfrSum;

        if (value.length === 0) {
            ModelCollect.TrsfrSum = 0;
        }
        setTimeout(() => {
            this.setState({
                ModelCollect
            });
        }, 100);
    };

    openCheckList = async () => {
        const {
            enableSpinner,
        } = this.props;

        enableSpinner(true);
        let getCuentaBancosResponse = await apiClient.getCuentaBancosList();
        // enableSpinner(false);


        // enableSpinner(true);
        let getCodigoEstadosResponse = await apiClient.getCodigoEstadosList();
        enableSpinner(false);

        await this.setState({
            checkItemCreateInfo: {
                banks: getCuentaBancosResponse.data,
                contries: getCodigoEstadosResponse.data,
            },
            ShowCheckListModal: !this.state.ShowCheckListModal
        });

        $('#checkListModal').modal('show');
    };

    Continue = async () => {
        const {
            notificationReducer: { showAlert },
        } = this.props;
        const { ModelCollect } = this.state;

        if (!ModelCollect.SerieCode) {
            showAlert({ type: 'info', message: "Selecciona una serie válida" });
            return;
        }

        setTimeout(() => {
            this.setState({
                ShowPaymentModal: !this.state.ShowPaymentModal
            });
        }, 100);

        $('#partialPaymentModal').modal('show');
    };

    Abonar = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ModelCollect, idWorkShift, allSN, perceptionsConfirmed = false, multiplePerceptions = [] } = this.state;

        ModelCollect.totalRecibido = Number(Number(ModelCollect.CashSum) + Number(ModelCollect.CreditSum) + Number(ModelCollect.CheckSum) + Number(ModelCollect.TrsfrSum)).toFixed(2);
        ModelCollect.TotalRecibido = Number(Number(ModelCollect.TotalRecibido).toFixed(2));

        if (Number(ModelCollect.TotalRecibido) < Number(ModelCollect.totalPago)) {
            showAlert({ type: 'error', message: 'El total del documento no corresponde al total de dinero recibido' });
            return;
        }

        let flagNeedReference = false;
        for (let p of ModelCollect?.PaymentsToSale) {
            if (needTransferReference(p, true)) {
                showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar una referencia${p.PM_Name ? ` para la forma de pago "${p.PM_Name}"` : ''}.`, timeOut: 8000 });
                flagNeedReference = true;
            }
        }
        if (flagNeedReference) {
            return;
        }

        //#region Flujo de caja
        if (Sections['FlujoCaja'] && ModelCollect?.PaymentsToSale?.length) {
            let missingCFWId = false;
            for (const element of ModelCollect?.PaymentsToSale) {
                if (element?.AcctCode) {
                    if (element?.needTransferCFW && !element?.transferCFWId) {
                        showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" de para la forma de pago "${element?.PM_Name || 'transferencia'}"`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                    if (element?.needCashCFW && !element?.cashCFWId) {
                        showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" para la forma de pago "${element?.PM_Name || 'efectivo'}"`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                    if (false // Este se queda comentado por que en sap no se muestra visualmente
                        && element?.needCheckCFW && !element?.checkCFWId) {
                        showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" para la forma de pago "${element?.PM_Name || 'cheques'}"`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                }
            }

            if (missingCFWId) { // No se completó la información de Flujo de caja
                return;
            }
        }
        //#endregion Flujo de caja

        ModelCollect.idSession = idWorkShift;
        ModelCollect.CardCode = ModelCollect.CardCode || ModelCollect.ItemsPayments?.[0]?.CardCode;
        ModelCollect.U_FMB_AUX_CARDNAME = ModelCollect.U_FMB_AUX_CARDNAME || ModelCollect.ItemsPayments?.[0]?.U_FMB_AUX_CARDNAME;
        //#region ################## POINTS CARD ################ ✔
        if (points_Card) {
            let search = {
                CardCode: ModelCollect.CardCode,
            }
            await this.searchPointsCard(search);
        }
        //#endregion ################## POINTS CARD ################ ✔
        let fletePayment = false;
        for (const invoice of ModelCollect.ItemsPayments) {
            if ((invoice?.U_FMB_RelatedFolio || "").slice(3, 5) === "CP") { fletePayment = true; }
        }
        ModelCollect.OriginDoc = 'Cobranza-Abonar';

        if (!allSN) { // Normal - 1 cliente
            const data = {
                destino: "ORCT",
                docSubType: "--",
                reserveInvoice: "tNO",
                model: ModelCollect,
                Time: moment().format(),
                UserTime: moment().format("HH:mm:ss"),
                ClientVersion: currentVersion,
                fletePayment
            };

            enableSpinner(true);
            let createDocumentResponse = await apiClient.createNewDocumentPS(data);
            enableSpinner(false);

            if (!createDocumentResponse.status || createDocumentResponse.status !== 1) {
                showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + createDocumentResponse.message, imeOut: 5000 });
                return;
            }

            $('#collectionModal').modal('hide');
            $('#collectModal').modal('hide');
            const showReport = false; // Si se descomenta revisar cuando son mas de 100 lineas en el pago
            if (showReport) {
                let payment = createDocumentResponse.data.serviceLayeResponse || {};
                let folio = createDocumentResponse.data.createdFolio || '';
                let paymentInvoices = payment.PaymentInvoices || [];
                let timbraResponse = payment.timbraResponse || null;
                await this.ShowCreatedPayment(folio, false, paymentInvoices, timbraResponse);
            }

            let document = createDocumentResponse.data;
            const docNum = createDocumentResponse?.data?.serviceLayeResponse?.DocNum || document?.createdFolio || '';
            showAlert({
                type: "success",
                message: `Pago exitoso con No. : ${docNum}`,
                timeOut: 15000,
            });

            await this.CargarDatos();
            ModelCollect.SerieCode = '';
            ModelCollect.CashAcct = '';
            ModelCollect.CashAcctFormatCode = '';
            ModelCollect.CashSum = '';
            ModelCollect.ItemsPayments = [];
            ModelCollect.PaymentsCreditCards = [];
            ModelCollect.CreditSum = '';
            ModelCollect.PaymentsToSale = [];
            ModelCollect.flagPointsCard = false;
            setTimeout(() => {
                this.setState({
                    ModelCollect,
                    ShowPaymentModal: !this.state.ShowPaymentModal,
                    ShowCheckListModal: false,
                    showCollectModalModal: false,
                    ShowPaymentCreditCardsModal: false,
                });
            }, 100);
        } else { // Multiples pagos a diferentes socios
            //#region Agrupar por CardCode
            let grouped = {};

            for (const element of ModelCollect.ItemsPayments) {
                const key = element.CardCode;

                if (!grouped[key]) {
                    grouped[key] = {
                        CardCode: element.CardCode,
                        CardName: element.CardName,
                        ItemsPayments: []
                    };
                }

                grouped[key].ItemsPayments.push(element);
            }
            //#endregion Agrupar por CardCode

            //#region Crear nuevos ModelCollect por cliente
            let modelsByClient = [];

            for (const key in grouped) {
                const group = grouped[key];

                // Clonar el modelo original
                let newModel = JSON.parse(JSON.stringify(ModelCollect));

                // Reemplazar datos del cliente
                newModel.CardCode = group.CardCode;
                newModel.CardName = group.CardName;

                // Reemplazar solo sus documentos
                newModel.ItemsPayments = group.ItemsPayments;
                modelsByClient.push(newModel);
            }
            //#endregion Crear nuevos ModelCollect por cliente
            //#region ASIGNAR MÉTODOS DE PAGO A CADA CLIENTE

            // Configuración de precisión
            const SCALE = 1000000;

            const toInt = (value) => Math.round(Number(value) * SCALE);
            const toNumber = (value) => Number((value / SCALE).toFixed(6));

            // Total global en entero
            let totalGlobal = 0;
            for (let p of ModelCollect.PaymentsToSale) {
                totalGlobal += toInt(p.Amount);
            }

            // Clonar métodos de pago (RESPETANDO ORDEN ORIGINAL)
            let availablePayments = JSON.parse(JSON.stringify(ModelCollect.PaymentsToSale));

            // Convertir a enteros
            for (let p of availablePayments) {
                p.Amount = toInt(p.Amount);
            }

            let totalDistribuido = 0;

            // Distribución por cliente
            for (let i = 0; i < modelsByClient.length; i++) {

                let model = modelsByClient[i];
                let amountToCover = 0;

                // Total que debe pagar el cliente
                for (const item of model.ItemsPayments) {
                    amountToCover += toInt(item.totalPago || 0) + toInt(item.U_PRC_IMP || 0);
                }

                let clientPayments = [];
                let totalAsignado = 0;

                // Consumir métodos en orden (flujo continuo)
                for (let payment of availablePayments) {

                    if (amountToCover <= 0) break;

                    let available = payment.Amount;
                    if (available <= 0) continue;

                    let amountUsed = Math.min(available, amountToCover);

                    let newPayment = { ...payment };
                    newPayment.Amount = amountUsed; // entero

                    clientPayments.push(newPayment);

                    payment.Amount -= amountUsed;
                    amountToCover -= amountUsed;

                    totalAsignado += amountUsed;
                }

                model._clientPaymentsInt = clientPayments;
                model._totalAsignadoInt = totalAsignado;

                totalDistribuido += totalAsignado;
            }

            // Ajuste por diferencias
            let diferencia = totalGlobal - totalDistribuido;

            if (diferencia !== 0 && modelsByClient.length > 0) {

                let lastModel = modelsByClient[modelsByClient.length - 1];

                if (lastModel._clientPaymentsInt.length > 0) {

                    let lastPayment = lastModel._clientPaymentsInt[lastModel._clientPaymentsInt.length - 1];

                    lastPayment.Amount += diferencia;
                    lastModel._totalAsignadoInt += diferencia;
                }
            }

            // Convertir a decimal (number) y limpiar
            for (let model of modelsByClient) {

                let totalPagoInt = 0;

                model.PaymentsToSale = model._clientPaymentsInt.map(p => {
                    totalPagoInt += p.Amount;

                    return {
                        ...p,
                        Amount: toNumber(p.Amount)
                    };
                });

                model.totalPago = toNumber(totalPagoInt);
                delete model._clientPaymentsInt;
                delete model._totalAsignadoInt;
            }

            //#endregion ASIGNAR MÉTODOS DE PAGO A CADA CLIENTE

            //#region DETECTAR PERCEPCIONES
            let perceptionsByClient = [];

            for (const model of modelsByClient) {

                const hasPerception = model.ItemsPayments.some(i => Number(i?.U_PRC_IMP) > 0);

                if (hasPerception) {
                    perceptionsByClient.push({
                        cardCode: model.CardCode,
                        cardName: model.CardName,
                        U_BPP_MDTDPaymentDefault: 40,
                        U_BPP_PTSCPaymentDefault: ''
                    });
                }
            }
            //#endregion

            //#region Ingresar series para percepciones
            if (perceptionsByClient?.length > 0 && !perceptionsConfirmed) {
                this.setState({
                    multiplePerceptions: perceptionsByClient,
                    modelsByClientPending: modelsByClient
                }, () => {
                    $("#multiplePerceptionsModal").modal("show");
                });

                return;
            }
            //#endregion

            //#region Asignar series de percepciones al pago a a crear
            if (perceptionsConfirmed && multiplePerceptions.length > 0) {

                modelsByClient = modelsByClient.map(model => {
                    const perc = multiplePerceptions.find(p => p.cardCode === model.CardCode);

                    if (perc) {
                        return {
                            ...model,
                            U_BPP_MDTDPaymentDefault: perc.U_BPP_MDTDPaymentDefault,
                            U_BPP_PTSCPaymentDefault: perc.U_BPP_PTSCPaymentDefault
                        };
                    }

                    return model;
                });
            }
            //#endregion

            let multiplePaymentsSummary = [];
            for (const ModelCollect of modelsByClient) {
                showAlert({ type: "info", message: `Realizando el pago al socio: ${ModelCollect.CardCode ?? ''}` });
                const data = {
                    destino: "ORCT",
                    docSubType: "--",
                    reserveInvoice: "tNO",
                    model: ModelCollect,
                    Time: moment().format(),
                    UserTime: moment().format("HH:mm:ss"),
                    ClientVersion: currentVersion,
                    fletePayment
                };

                enableSpinner(true);
                let createDocumentResponse = await apiClient.createNewDocumentPS(data);
                enableSpinner(false);

                const docNum = createDocumentResponse?.data?.serviceLayeResponse?.DocNum ?? '';
                const createdFolio = createDocumentResponse?.data?.createdFolio ?? '';
                const isSuccess = createDocumentResponse?.status;

                multiplePaymentsSummary.push({
                    cardCode: ModelCollect.CardCode ?? '',
                    paymentDocNum: docNum || "",
                    paymentMessage: !isSuccess ? createDocumentResponse?.message || "Ocurrió un error al intentar crear el Pago" : 'Pago exitoso',
                    status: isSuccess ? "success" : "error",
                    folio: createdFolio ?? ''
                });
            }

            this.setState({
                multiplePaymentsSummary,
            }, () => {
                this.showMultiplePaymentsSummary();
            });
        }
    }

    depositos = async (action = null, checkboxDataTables) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { dataInvoice, ModelCollect, series } = this.state;
        if (action === 1) {
            let docEntryArray = [];

            for (let [id, value] of checkboxDataTables.entries()) {
                if (value) {
                    docEntryArray.push(dataInvoice[id]);
                }
            }

            if (docEntryArray.length === 0) {
                showAlert({ type: 'warning', message: "Seleccione un documento a registar los depositos" });
                return;
            }

            if (docEntryArray?.some(doc => doc.DocCur !== docEntryArray?.[0]?.DocCur)) {
                showAlert({ type: 'warning', message: "Todos los documentos seleccionados deben de tener la misma moneda" });
                return;
            }

            if (docEntryArray?.some(doc => doc.CardCode !== docEntryArray?.[0]?.CardCode)) {
                showAlert({ type: 'warning', message: "Todos los documentos seleccionados deben de pertenecer al mismo cliente" });
                return;
            }
            let total = 0;

            //#region CREDIT PERCEPTIONS
            let perceptionData = [...docEntryArray];

            enableSpinner(true);

            let checkPerceptions;
            try {
                showAlert({ type: 'info', message: 'Revisando percepciones, por favor espere.' });
                checkPerceptions = await apiClient.perceptionJournalEntries(perceptionData);
            } catch (error) {
                showAlert({ type: 'error', message: 'Error al validar percepciones' });
                enableSpinner(false);
                return;
            }

            enableSpinner(false);

            if (!checkPerceptions?.status) {
                showAlert({ type: 'error', message: 'Ocurrió un error al validar las percepciones' });
                return;
            }

            const validPerceptionJE = [];

            for (const line of (checkPerceptions?.data ?? [])) {
                if (line?.TransIdError || line?.creditPerceptionError) {
                    const { DocNum } = line ?? {};
                    showAlert({
                        type: 'error',
                        message: `Ocurrió un error al validar las percepciones de la factura ${DocNum ?? ''}`,
                        timeOut: 8000
                    });
                } else {
                    validPerceptionJE.push(line);
                }
            }

            docEntryArray = validPerceptionJE;
            //#endregion CREDIT PERCEPTIONS

            //#region CESION USO CONTADO
            enableSpinner(true);
            let validateCUSO = await apiClient.validateCUso({ Documents: docEntryArray });
            enableSpinner(false);
            //#endregion CESION USO CONTADO
            if (validateCUSO.status == 1) {
                docEntryArray = validateCUSO?.data ?? docEntryArray
            }

            let globalCurrency = docEntryArray?.[0]?.DocCur;

            const newItemsPayments = docEntryArray.map(element => {
                const totalPago = globalCurrency === CURRENCY ? Number(element?.totalPago ?? 0).toFixed(2) : Number(element?.totalPagoFC ?? 0).toFixed(2);
                const U_PRC_IMP = globalCurrency === CURRENCY ? Number(element?.U_PRC_IMP ?? 0) : 0;
                const originalU_PRC_IMP = globalCurrency === CURRENCY ? Number(element?.originalU_PRC_IMP ?? 0) : 0;
                const U_STR_FE_Tasa_Percepcion = globalCurrency === CURRENCY ? Number(element?.U_STR_FE_Tasa_Percepcion ?? 0) : 0;
                const auxOriginalU_PRC_IMP = globalCurrency === CURRENCY ? Number(element?.auxOriginalU_PRC_IMP ?? 0) : 0;
                const auxU_STR_FE_Tasa_Percepcion = globalCurrency === CURRENCY ? Number(element?.auxU_STR_FE_Tasa_Percepcion ?? 0) : 0;
                const auxU_PRC_IMP = globalCurrency === CURRENCY ? Number(element?.auxU_PRC_IMP ?? 0) : 0;
                const PorVencer = globalCurrency === CURRENCY ? Number(element?.PorVencer ?? 0) : Number(element?.PorVencerFC ?? 0);
                // Si la moneda es extrajera, las percepciones se van a 0 por que el campo guardó el valor de la percepcion en moneda local

                total += PorVencer;

                return {
                    ...element,
                    totalPago,
                    U_Parcialidad: '1',
                    U_PRC_IMP, // Importe a pagar de la percepción
                    originalU_PRC_IMP, // Valor total de la percepción
                    auxU_PRC_IMP, // Total restante a pagar de la percepción
                    U_STR_FE_Tasa_Percepcion, // % de percepción grabado - Determinado por calculo
                    auxOriginalU_PRC_IMP, // Total original de la percepción - En pagos - Grabado en el documento
                    auxU_STR_FE_Tasa_Percepcion, // % de percepción grabado - Grabado en el documento
                };
            });

            let defaultName = "";
            let defaultcode = "";
            let nextNumber = "";

            if (series.length === 1) {
                const serie = series[0];
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber;
            }

            let newModelCollect = {
                ...ModelCollect,
                SerieName: defaultName,
                SerieCode: defaultcode,
                NextFolio: nextNumber,
                ItemsPayments: newItemsPayments,
                total,
                U_BPP_MDTDPaymentDefault: '',
                U_BPP_PTSCPaymentDefault: ''
            };

            newModelCollect.CardCode = newModelCollect.ItemsPayments?.[0]?.CardCode;
            newModelCollect.CardName = newModelCollect.ItemsPayments?.[0]?.CardName;

            this.setState(
                {
                    ModelCollect: newModelCollect,
                    showCollectDeposits: true,
                    globalCurrency
                },
                () => {
                    $("#CollectDepositsModal").modal("show");
                }
            );

            return;
        }

        $("#CollectDepositsModal").modal("hide");
        this.setState({
            showCollectDeposits: false
        },
            () => {
                if (action === 2) {
                    this.CargarDatos()
                }
            }
        )
    };

    refreshTotal = (ModelCollect, index = null) => {

        ModelCollect.totalDocumento = 0;
        ModelCollect.totalPago = 0;
        ModelCollect.CheckSum = 0;

        ModelCollect.ItemsPayments.map(item => {
            ModelCollect.totalDocumento += Number(item.DocTotal - item.PaidToDate); //item.total
            ModelCollect.totalPago += Number(item.totalPago);
        });
        ModelCollect.totalDocumento = ModelCollect.totalPago;
        ModelCollect.CheckList.map(item => {
            ModelCollect.CheckSum += Number(item.CheckSum);
        });

        if (ModelCollect.PayNoDoc) {
            ModelCollect.totalDocumento = ModelCollect.NoDocSum;
        }

        ModelCollect.totalPago = Number((ModelCollect.totalPago).toFixed(2));
        ModelCollect.totalRestante = ModelCollect.totalPago - ModelCollect.totalRecibido;
        this.refreshModel(ModelCollect);
    };

    refreshModel = ModelCollect => {
        this.setState({
            ModelCollect
        })
    };

    addNewItemCheck = () => {
        const { ModelCollect } = this.state;

        let newItem = new NewItemCheck();

        ModelCollect.CheckList.push(newItem);
        this.refreshModel(ModelCollect);
    };

    deleteItemCheck = indexToDelete => {
        const { ModelCollect } = this.state;

        let newItems = [];

        ModelCollect.CheckList.map((item, index) => {
            if (indexToDelete != index) {
                newItems.push(item);
            }
        });

        ModelCollect.CheckList = newItems;
        this.refreshTotal(ModelCollect);
    };

    SearchPayment = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { folio, cliente } = this.state;

        if (folio === '') {
            showAlert({ type: 'warning', message: 'Escribe el número de folio' });
            return;
        }
        let datos = {
            folio,
            cliente,
        }
        enableSpinner(true);
        let IncomingPayments = await apiClient.getIncomingPayments(datos);
        enableSpinner(false);
        if (IncomingPayments.status === SERVICE_RESPONSE.SUCCESS) {

            let newOrderModel = this.createNewOrderDetails(IncomingPayments);

            this.setState({
                newOrderModel: newOrderModel,
                showPaymentModal: !this.state.showPaymentModal,
            });

            $('#paymentModal').modal({ backdrop: 'static', keyboard: false }, 'show');
            return;
        } else {
            this.setState({
                showPaymentModal: false,
            });
        }
        showAlert({ type: 'error', message: IncomingPayments.message });
    }

    createNewOrderDetails = (detailsResponse) => {
        let newOrderModel = new NewOrder();

        let header = detailsResponse.data.header;
        let items = detailsResponse.data.items || [];
        let checks = detailsResponse.data.paymentChecks;

        newOrderModel.OriginDocumentCreate = 'payment';
        newOrderModel.userFields = [];
        newOrderModel.ObjType = header.ObjType;
        newOrderModel.DocType = header.DocType;
        newOrderModel.DocumentType = "F";
        newOrderModel.WddStatus = header.WddStatus;
        newOrderModel.DocEntry = header.DocEntry || "";
        newOrderModel.DocEntryRel = header.DocEntryRel || "";
        newOrderModel.CardCode = header.CardCode;
        newOrderModel.Balance = header.Balance || 0;
        newOrderModel.UserID = 0;
        newOrderModel.DocStatus = header.DocStatus;
        newOrderModel.CardName = header.CardName;
        newOrderModel.NextFolio = header.DocNum;
        newOrderModel.DocNum = header.DocNum;
        newOrderModel.StatusDocument = '';
        newOrderModel.NumAtCard = header.NumAtCard;
        newOrderModel.SerieName = header.SeriesName;
        newOrderModel.SerieCode = header.Series;
        newOrderModel.ExtraDays = header.metodoPago;
        newOrderModel.SerieArray = [];
        newOrderModel.DocDate = moment(header.DocDate).format('YYYY-MM-DD');
        newOrderModel.DocDueDate = moment(header.DocDueDate).format('YYYY-MM-DD');
        newOrderModel.TaxDate = moment(header.TaxDate).format('YYYY-MM-DD');
        newOrderModel.ReqDate = moment(header.ReqDate).format('YYYY-MM-DD');
        newOrderModel.ReqType = header.ReqType;
        newOrderModel.Requester = header.Requester;
        newOrderModel.ReqName = header.ReqName;
        newOrderModel.Branch = header.Branch;
        newOrderModel.BranchName = header.BranchName;
        newOrderModel.Department = header.Department;
        newOrderModel.DepartmentName = header.DepartmentName;
        newOrderModel.Email = header.Email;
        newOrderModel.Notify = header.Notify;
        newOrderModel.SlpCode = header.SlpCode;
        newOrderModel.SlpName = header.SlpName;
        newOrderModel.CntctCode = header.CntctCode;
        newOrderModel.CntctName = header.CntntName;
        newOrderModel.OwnerCode = header.OwnerCode || "";
        newOrderModel.OwnerName = header.OwnerName || "";
        newOrderModel.Comments = header.Comments || "";
        newOrderModel.Status = '';
        newOrderModel.StepCode = '';
        newOrderModel.WtmName = '';
        newOrderModel.Subtotal = 0;
        newOrderModel.DiscountPercent = parseFloat(header.DiscPrcnt).toFixed(2);
        newOrderModel.Discount = 0;
        newOrderModel.Taxes = 0;
        newOrderModel.Total = 0;
        newOrderModel.Items = [];

        newOrderModel.GroupNum = header.GroupNum;
        newOrderModel.GroupName = header.condicionesPago;
        newOrderModel.GroupCode = header.GroupCode;
        newOrderModel.PymCode = header.PeyMethod;
        newOrderModel.PymName = header.payDescription;
        newOrderModel.indexRowDetails = '';

        //Direccion de entrega para documentos generales
        newOrderModel.Address2 = header.Address2;
        newOrderModel.ShipToCode = header.ShipToCode;
        // definido desde el usuario
        newOrderModel.TaxeDefaultPartner = header.TaxCode || '';
        newOrderModel.TaxeRateDefaultPartner = header.TaxCodeRate || '';
        newOrderModel.OcrCode2DefaultPartner = header.OcrCode2 || '';
        newOrderModel.AcctCodeDefaultPartner = header.AcctCodeItem || '';
        newOrderModel.CogsAcctDefaultPartner = header.CogsAcctItem || '';
        newOrderModel.AcctCodeNameDefaultPartner = header.AcctCodeItemName || '';
        newOrderModel.CogsAcctNameDefaultPartner = header.CogsAcctItemName || '';

        //Trasnfers
        newOrderModel.Address = header.Address;
        newOrderModel.Filler = header.Filler;
        newOrderModel.FillerName = "";
        newOrderModel.PickRmrk = header.PickRmrk || '';
        newOrderModel.ToWhsCode = header.ToWhsCode || '';
        newOrderModel.ToWhsCodeName = "";
        newOrderModel.JrnlMemo = header.JrnlMemo;
        newOrderModel.GroupNumTraslado = header.GroupNum;
        newOrderModel.GroupNumTrasladoName = header.ListName;
        //Pagos
        newOrderModel.TransId = header.TransId || "";
        newOrderModel.CounterRef = header.CounterRef || "";
        newOrderModel.NoDocSum = parseFloat(header.NoDocSum).toFixed(2) || 0;
        newOrderModel.BpAct = header.BpAct || "";
        newOrderModel.BpActFormatCode = header.BpActFormatCode || "";
        newOrderModel.BpActName = "";
        newOrderModel.PayNoDoc = header.PayNoDoc === 'Y' ? true : false;
        newOrderModel.CashSum = header.DocCurr === 'SOL' ? header.CashSum : header.CashSumFC;
        newOrderModel.CreditSum = header.DocCurr === 'SOL' ? header.CreditSum : header.CredSumFC;
        newOrderModel.CheckSum = header.DocCurr === 'SOL' ? header.CheckSum : header.CheckSumFC;
        newOrderModel.TrsfrSum = header.DocCurr === 'SOL' ? header.TrsfrSum : header.TrsfrSumFC;
        // trasferencias
        newOrderModel.TrsfrAcct = header.TrsfrAcct;
        newOrderModel.TrsfrAcctName = header.TrsfrAcctName;
        newOrderModel.TrsfrDate = moment(header.TrsfrDate).add(1, 'd').format('YYYY-MM-DD');
        newOrderModel.TrsfrRef = header.TrsfrRef;
        newOrderModel.TrsfrAcctFormatCode = header.TrsfrAcctFormatCode;
        // cheques
        newOrderModel.CheckAcct = header.CheckAcct;
        newOrderModel.CheckList = checks;
        newOrderModel.CheckAcctFormatCode = header.CheckAcctFormatCode;
        //cash
        newOrderModel.CashAcct = header.CashAcct;
        newOrderModel.CashAcctFormatCode = header.CashAcctFormatCode;

        //Lista de precios C100 /
        newOrderModel.PriceListNum = header.ListNum || "";
        //CreditLine
        newOrderModel.CreditLine = header.CreditLine || 0;
        newOrderModel.transactionId = header.TransId || '';
        newOrderModel.PaidToDate = header.PaidToDate || 0;
        newOrderModel.BackOrder = header.BackOrder || '';
        newOrderModel.PartDelivr = header.PartDelivr || '';
        newOrderModel.folio = header.folio;


        //Tipo cambiario
        newOrderModel.DocCur = header.DocCurr;
        newOrderModel.ChangeRate = header.DocRate || 1;
        let newService = [];
        let newItemsPayment = [];
        let lastLineNum = items.length;

        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            let itemModelPayment = new NewItemPayment();

            if ((lastLineNum - 1) === index) {
                newOrderModel.LastLineNumItems = item.LineNum;
            }

            itemModelPayment.DocEntry = item.DocEntry;
            itemModelPayment.DocNum = item.DocNum;
            itemModelPayment.docType = item.ObjType;
            itemModelPayment.DocSubType = item.DocSubType;
            itemModelPayment.RefDate = moment(item.TaxDate).add(1, 'd').format('YYYY-MM-DD');
            itemModelPayment.daysLast = 0;
            itemModelPayment.total = item.DocCur === 'SOL' ? item.DocTotal : item.DocTotalFC;
            itemModelPayment.pastDueBalance = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidToDate) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.totalPago = item.DocCur === 'SOL' ? parseFloat(item.totalPago ? item.totalPago : item.PaidSum).toFixed(4) : item.totalPagoFC;
            itemModelPayment.DocCur = item.DocCur;
            itemModelPayment.totalOutgoing = item.DocCur === 'SOL' ? item.SumApplied : item.totalPagoFC;
            itemModelPayment.saldoVencido = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidSum) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.OcrCode = item.OcrCode;
            itemModelPayment.OcrName = "";
            itemModelPayment.OcrCode2 = item.OcrCode2;
            itemModelPayment.OcrName2 = "";
            itemModelPayment.OcrCode3 = item.OcrCode3;
            itemModelPayment.OcrName3 = "";
            itemModelPayment.OcrCode4 = item.OcrCode4;
            itemModelPayment.OcrName4 = "";
            itemModelPayment.OcrCode5 = item.OcrCode5;
            itemModelPayment.OcrName5 = "";

            newItemsPayment.push(itemModelPayment);
        }

        newOrderModel.service = newService;
        newOrderModel.ItemsPayments = newItemsPayment;

        if (newOrderModel.WddStatus === "P") {
            newOrderModel.isDocumentWithAuthorization = true; // servicio 2 donde no actualiza los items solo el documento
        }

        //PAGOS
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalPago = 0;
        newOrderModel.CheckSum = 0;

        newOrderModel.ItemsPayments.map(item => {
            newOrderModel.totalDocumento += Number(item.pastDueBalance); //item.total
            newOrderModel.totalPago += Number(item.totalPago);
        });

        newOrderModel.CheckList.map(item => {
            newOrderModel.CheckSum += Number(item.CheckSum);
        });

        if (newOrderModel.PayNoDoc) {
            newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        }


        newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        if (newOrderModel.DocCur != newOrderModel.DocCurDocumentsPayment) {
            let localCurrency = CURRENCY;
            let rate = 1;
            if (localCurrency == newOrderModel.DocCur) {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });

                newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
            } else {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCur == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });
                newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
            }
        }

        newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;

        // Datos para cancelación
        newOrderModel.IdSession = header.idSession ?? null;

        return newOrderModel;

    };

    CloseModalPayment = () => {
        $('#paymentModal').modal('hide');
        this.setState({
            showPaymentModal: false,
        });
    }

    CancelPaymentSAP = async () => {
        const {
            enableSpinner,
            notificationReducer: { showAlert },
        } = this.props;
        const { newOrderModel, idWorkShift, cancelCurrentDate } = this.state;

        let datos = {
            id: newOrderModel.folio,
            idSession: cancelCurrentDate ? idWorkShift : newOrderModel.IdSession,
            currentDate: cancelCurrentDate,
        }
        enableSpinner(true);

        let CancelIncomingPayments = await apiClient.CancelIncomingPayments(datos);

        enableSpinner(false);

        if (CancelIncomingPayments.status === SERVICE_RESPONSE.SUCCESS) {
            $('#paymentModal').modal('hide');
            showAlert({
                type: "success",
                message: CancelIncomingPayments.message,
                timeOut: 5000,
            });
            this.setState({
                newOrderModel: [],
                showAreYouAgreeModal: false,
                showPaymentModal: false,
            });

            const document = newOrderModel.folio;
            let data = {
                doc: document.substring(5, 50),
                table: 'ORCT',
                docSubType: "--",
                view: "payment",
                view2: "payment"
            };
            enableSpinner(true);
            let responseApi = await apiClient.getDocumentsDetails(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                this.CloseCreatedInvoiceActions();
                return;
            }
            const documents = responseApi.data.items;
            let lineas = [];
            enableSpinner(true);
            for (let index = 0; index < documents.length; index++) {
                const element = documents[index];

                let docsToPrintIds = [];
                docsToPrintIds.push('00000' + element.DocEntry);
                let data = {
                    docsToPrintIds,
                    typeDoc: 13
                }
                let response = await apiClient.getPrintDocsInfo(data);
                if (response.status === 1) {
                    lineas.push(response.data[0].docHeader.responseHeader)
                }
            }
            enableSpinner(false);

            responseApi.data.header.folio = document;
            responseApi.data.header.canceled = true;
            responseApi.data.items = lineas;
            let docs = [responseApi.data];
            await this.setState({
                docsToPrint: docs ?? [],
                typeDocPrint: 'OINV', ordersToAction: document, EnableEditButton: false, showPDFViewer: !this.state.showPDFViewer,
            });
            $("#pdfViewer").modal("show");

            return;
        } else {
            showAlert({
                type: "warning",
                message: CancelIncomingPayments.message,
                timeOut: 5000,
            });

            await this.setState({
                showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
            });
        }

    }

    ValidateCancelDate = async () => {
        const { newOrderModel } = this.state;
        const documentDate = moment(newOrderModel.TaxDate).utc().format("DD-MM-YYYY");
        const todayDate = moment(new Date()).format("DD-MM-YYYY");
        if (documentDate !== todayDate) { $('#cancelDateModal').modal({ backdrop: 'static', keyboard: false }, 'show'); }
        else { this.OpenShowAreYouAgreeModal(); }
    }

    changeCancelDate = async (value) => {
        await this.setState({ cancelCurrentDate: value });
    }

    OpenShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });
        $('#areYouAgreeModal').modal('show');
    }

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
        });
    }

    changeCancelMode = async () => {
    }
    changeDocumentDate = async () => {
    }
    resetPaymentsToCancel = async () => {
    }

    ConsultarEstatusPagoCFDI = async (DocEntry) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let data = {
            DocEntry,
            Table: {
                name: 'ORCT',
            }
        }

        enableSpinner(true);
        let response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);
        await this.setState({ PaymentStatus: response.paymentStatus })
        $('#paymentStatusListModal').modal('show');

        if (response.status === 1) { //Documento cancelado
            newOrderModel.IsCancelSAP = true;
            newOrderModel.StatusCFDI = true;
            await this.setState({
                newOrderModel
            })
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) { //Cancelable 
            newOrderModel.StatusCFDI = true;
            await this.setState({ newOrderModel })
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            return showAlert({ type: "warning", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    }

    ShowCancelConfirm = async () => {
        $('#cancelCFDI').modal('show');
        let CancelFunction = this.CancelPaymentCFDI;
        await this.setState({
            CancelFunction
        })

    }
    CancelPaymentCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        $('#cancelCFDI').modal('hide');

        let motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : '';

        if (motivo === '00') {
            return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelacion no es un valor válido`, timeOut: 8000 });
        } else if (motivo === '01' && U_FMB_UUID_RELACIONADO === '') {
            return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        }

        let data = {
            DocEntry: newOrderModel.DocEntry,
            Table: {
                name: 'ORCT',
            },
            Motivo: motivo || '02',
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || '',

        }

        $('#cancelDocuments').modal('hide');

        enableSpinner(true);
        let response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        $('#cancelCFDI').modal('hide');
        if (response.status === 0) {
            newOrderModel.IsCancelSAP = false;
            newOrderModel.StatusCFDI = false;
            await this.setState({
                newOrderModel
            })
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            newOrderModel.IsCancelSAP = false;
            newOrderModel.StatusCFDI = false;
            await this.setState({
                newOrderModel
            })
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            newOrderModel.IsCancelSAP = true;
            newOrderModel.StatusCFDI = true;
            await this.setState({
                newOrderModel
            })
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    changeAccountCashAcct = event => {
        const { ModelCollect } = this.state;
        ModelCollect.CashAcctFormatCode = event.nativeEvent.target.value;;

        this.setState({
            ModelCollect
        });
    };

    changeAccountCheck = event => {
        const { ModelCollect } = this.state;
        ModelCollect.CheckAcctFormatCode = event.nativeEvent.target.value;;

        this.setState({
            ModelCollect
        });
    };

    changeAccountTrsfr = event => {
        const { ModelCollect } = this.state;
        ModelCollect.TrsfrAcctFormatCode = event.nativeEvent.target.value;;

        this.setState({
            ModelCollect
        });
    };

    //#region PAGOS CON TARJETA
    OpenPaymentCreditCards = async () => {
        await this.setState({
            ShowPaymentCreditCardsModal: !this.state.ShowPaymentCreditCardsModal
        });

        $('#paymentCreditCardsModal').modal('show');
    };

    ClosePaymentCreditCardsModal = async () => {
        await this.setState({
            ShowPaymentCreditCardsModal: !this.state.ShowPaymentCreditCardsModal
        });
    }

    selectTabCard = (cardId) => {
        const { ModelCollect } = this.state;
        for (let index = 0; index < ModelCollect.PaymentsCreditCards.length; index++) {
            const tabCard = ModelCollect.PaymentsCreditCards[index];
            if (cardId === index) {
                tabCard.isSelected = true;
            } else {
                tabCard.isSelected = false;
            }
        }
        this.setState({
            cardId
        });
        this.refreshModel(ModelCollect);
    }

    addCreditCard = () => {
        const { ModelCollect } = this.state;
        let newCreditCard = new CreditCards();
        newCreditCard.isSelected = false;
        ModelCollect.PaymentsCreditCards.push(newCreditCard);
        this.refreshModel(ModelCollect);
    }

    deleteCard = (cardID) => {
        const { ModelCollect } = this.state;
        ModelCollect.PaymentsCreditCards.splice(cardID, 1);
        this.refreshModel(ModelCollect);
    }

    openCard = async (index) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        let response = await apiClient.getCards();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            cardList: response.data,
            cardLine: index
        });

        $('#cardsListModal').modal('show');
    };

    selectCardList = async (action) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { cardList, cardLine, ModelCollect } = this.state;
        let card = cardList[action.index];

        enableSpinner(true);
        let response = await apiClient.getCard(card.CreditCard);
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        ModelCollect.PaymentsCreditCards[cardLine].CreditCard = card.CreditCard || '';
        ModelCollect.PaymentsCreditCards[cardLine].LineNum = cardLine;
        ModelCollect.PaymentsCreditCards[cardLine].CrTypeCode = response.data[0].CrTypeName || '1';
        ModelCollect.PaymentsCreditCards[cardLine].OwnerPhone = card.Phone || '';
        ModelCollect.PaymentsCreditCards[cardLine].MaxValid = response.data[0].MaxValid || 0;
        ModelCollect.PaymentsCreditCards[cardLine].CardName = card.CardName || '';
        ModelCollect.PaymentsCreditCards[cardLine].CreditAcct = card.AcctCode || '';

        this.refreshModel(ModelCollect);

        $('#cardsListModal').modal('hide');
    };

    validateCardNum = (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        //  let regex = /^(?:4\d([\- ])?\d{6}\1\d{5}|(?:4\d{3}|5[1-5]\d{2}|6011)([\- ])?\d{4}\2\d{4}\2\d{4})$/;
        let regex = /^\d{4}$/;
        if (regex.test(value)) {
            return;
        }
        showAlert({ type: 'info', message: 'Formato de tarjeta no valido' });
    };

    changeCardNum = (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;

        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        ModelCollect.PaymentsCreditCards[cardId].CrCardNum = value;
        this.refreshModel(ModelCollect);
    };

    changeCardValid = (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        value = value.replace('/', '');
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        if (value.length > 2) {
            if (value.slice(0, 2) > 12) {
                showAlert({ type: 'info', message: 'Fecha incorrecta' });
                return;
            }
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        ModelCollect.PaymentsCreditCards[cardId].CardValid = value;
        this.refreshModel(ModelCollect);
    };

    changeValidateValidCard = async (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        if (ModelCollect.PaymentsCreditCards[cardId].length < 5) {
            showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
            return
        }
    };

    changeOwnerIdNum = (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        ModelCollect.PaymentsCreditCards[cardId].OwnerIdNum = value;
        this.refreshModel(ModelCollect);
    };

    changeOwnerPhone = (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        ModelCollect.PaymentsCreditCards[cardId].OwnerPhone = value;
        this.refreshModel(ModelCollect);
    };

    keydownHandler = (event, cardId) => {
        const { ModelCollect } = this.state;
        if (event.key.toLowerCase() === 'b' && event.shiftKey) {
            ModelCollect.CreditSum = ModelCollect.totalPago;
            ModelCollect.PaymentsCreditCards[cardId].CreditSum = ModelCollect.totalPago;
            this.refreshTotal(ModelCollect);
        }
    };

    changeCreditSum = (value, cardId) => {
        const { ModelCollect } = this.state;

        if (isNaN(value)) {
            return;
        }
        ModelCollect.PaymentsCreditCards[cardId].CreditSum = value;

        let newModel = this.sumCheck(ModelCollect);
        this.refreshTotal(newModel);
    };

    sumCheck = model => {
        let suma = 0;
        let credits = model.PaymentsCreditCards || [];
        credits.map(credit => {
            suma += parseFloat(credit.CreditSum || 0);
        })

        model.CreditSum = suma;
        return model;
    }

    changeTransfersRef = event => {
        const { ModelCollect } = this.state;

        ModelCollect.TrsfrRef = event.nativeEvent.target.value;
        this.refreshModel(ModelCollect);
    };

    changeVoucherNum = (value, cardId) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        ModelCollect.PaymentsCreditCards[cardId].VoucherNum = value;
        this.refreshModel(ModelCollect);
    };

    changeCreditType = async (value, cardId) => {
        const { ModelCollect } = this.state;
        ModelCollect.PaymentsCreditCards[cardId].CreditType = value;
        this.refreshModel(ModelCollect);
    };

    changeCreditSumOne = event => {
        const { ModelCollect } = this.state;

        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data !== ' ') {
                ModelCollect.CreditSum = event.nativeEvent.target.value;
            }
        }
        this.refreshTotal(ModelCollect);
    };

    SelectAccountListCredit = action => {
        const { accountsCredit, cardId, ModelCollect } = this.state;
        let account = accountsCredit[action.index];

        ModelCollect.PaymentsCreditCards[cardId].CreditAcct = account.AcctCode || '';

        $('#AccountListModal').modal('hide');

        setTimeout(() => {
            this.setState({
                ModelCollect,
                ShowAccountsModalCredit: false,
            });
        }, 100);
    };

    OpenCuentaMayorCredit = async (index = null, cuenta) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        enableSpinner(true);
        let response = await apiClient.getCuentaMayor();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accountsCredit: response.data,
            ShowAccountsModalCredit: !this.state.ShowAccountsModalCredit,
        });

        $('#AccountListModal').modal('show');
    };

    //#endregion

    //#region --------PAGOS--------
    AplicarPago = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ModelCollect, writeAccess, allSN } = this.state;

        if (!writeAccess) {
            showAlert({ type: 'info', message: "TU PERFIL NO TIENE PERMISO PARA REALIZAR ESTA ACCIÓN", timeOut: 5000 });
            return;
        }

        if (!ModelCollect.SerieCode) {
            showAlert({ type: 'info', message: "Selecciona una serie válida", timeOut: 5000 });
            return;
        }

        if (!allSN && ModelCollect?.ItemsPayments?.some(row => Number(row.U_PRC_IMP) > 0) && !ModelCollect.U_BPP_PTSCPaymentDefault) {
            showAlert({ type: 'info', message: `Es necesario un valor para el campo "Serie del documento"`, timeOut: 5000 });
            return;
        }
        if (!await this.GetCurrencies(ModelCollect.DocDate)) return;
        // setTimeout(() => {
        this.setState({
            showBillModal: !this.state.showBillModal
        });
        // }, 100);
        await this.SumOfAmounts();

        $('#collectionModal').modal('show');
    };

    ShowBillModal = async () => {
        const { isCancel } = this.state;
        await this.setState({ showBillModal: isCancel || !this.state.showBillModal });
    };

    CloseBillModal = async (ticket) => {
        let { ModelCollect, _user } = this.state;
        let partner = _user?.Partner;
        ModelCollect.TotalRestante = 0;
        if (ticket) {
            ModelCollect = []; //new NewOrderSales();--DESCOMENTAR
            ModelCollect.TaxCode = partner.TaxCode;
            ModelCollect.TaxName = partner.TaxName;
            ModelCollect.TaxRate = partner.Rate;
            ModelCollect.CardCode = partner.CardCode;
            ModelCollect.CardName = partner.CardName;
            ModelCollect.PriceListNum = partner.ListNum;
            ModelCollect.ShipToDef = partner.ShipToDef;
            ModelCollect.BillToDef = partner.BillToDef;
        }
        await this.setState({
            ModelCollect,
            showBillModal: false,
            itemSelected: {},
            showrefund: false,
        });
    };

    RefreshOrder = async (ModelCollect) => {
        this.setState({ ModelCollect });
    };

    CancelPayment = async () => {
        const { ModelCollect } = this.state
        await this.setState({
            isCancel: true,
            DownPayments: [],
            CreditNotes: [],
        });
        ModelCollect.PaymentsToSale = [];
        ModelCollect.PaymentsToReturn = [];
        this.RefreshOrder(ModelCollect);
        if (this.state.showBillModal === true) {
            await this.ShowBillModal();
        }
        await this.RefreshTotal(ModelCollect);
    };

    ValidateDocument = async () => {
        const { ModelCollect } = this.state;
        const { notificationReducer: { showAlert } } = this.props;
        if (Number(ModelCollect.Total) > Number(ModelCollect.TotalRecibido)) {
            showAlert({ type: "warning", message: "Ingrese el monto total a pagar", timeOut: 2000 });
            return;
        }
        $("#billModal").modal("hide");
        $("#validationModal").modal("show");
    };

    ValidateInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ModelCollect, requireInvoice } = this.state;
        if (requireInvoice) {
            let requestData = {
                cardCode: ModelCollect.CardCode
            }
            enableSpinner(true);
            let responseAddress = await apiClient.ValidateBPToDH(requestData);
            enableSpinner(false);
            if (responseAddress.status !== 1) {
                showAlert({ type: 'warning', message: 'ALGO SALIO MAL AL CONSULTAR LAS DIRECCIÓNES DISPONIBLES ' });
                return;
            }
            let shipAddressArray = responseAddress.data.deliveriesAddress || [];
            let billAddressArray = responseAddress.data.invoicesAddress || [];

            let infoByFolio = [];//new InfoByFolio();--DESCOMENTAR
            let responseHeader = [];//new ResponseHeader();--DESCOMENTAR
            let billAddress = [];//new BillAddress();--DESCOMENTAR
            let shipAddress = [];//new ShipAddress();--DESCOMENTAR

            infoByFolio.CashSum = ModelCollect.CashSum;
            infoByFolio.CheckSum = ModelCollect.CheckSum;
            infoByFolio.CreditSum = ModelCollect.CreditSum;
            infoByFolio.TrsfrSum = ModelCollect.TrsfrSum;
            infoByFolio.cardCode = ModelCollect.CardCode;
            infoByFolio.docDate = ModelCollect.DocDate;
            infoByFolio.docEntry = ModelCollect.DocEntry;
            infoByFolio.docNum = ModelCollect.DocNum;
            infoByFolio.docObjectType = ModelCollect.ObjType;
            infoByFolio.docStatus = ModelCollect.DocStatus;
            infoByFolio.folio = ModelCollect.DocNum;
            infoByFolio.idSale = ModelCollect.DocNum;
            infoByFolio.serie = ModelCollect.SerieCode;
            infoByFolio.taxTotal = Number(ModelCollect.Taxes);

            responseHeader.BillDirection = '';
            responseHeader.CardCode = ModelCollect.CardCode;
            responseHeader.CardName = ModelCollect.CardName;
            responseHeader.Cellular = ModelCollect.Phone;
            responseHeader.DiscPrcnt = ModelCollect.DiscPrcnt;
            responseHeader.DocCur = ModelCollect.DocCur || 'SOL';
            responseHeader.DocDate = ModelCollect.DocDate;
            responseHeader.DocDueDate = ModelCollect.DocDueDate;
            responseHeader.DocEntry = ModelCollect.docEntry;
            responseHeader.DocNum = ModelCollect.NextFolio || 112;
            responseHeader.DocStatus = ModelCollect.DocStatus;
            responseHeader.DocTotal = Number(ModelCollect.Total);
            responseHeader.E_Mail = ModelCollect.Email;
            responseHeader.LicTradNum = ModelCollect.LicTradNum;
            responseHeader.PayToCode = ModelCollect.PymCode;
            responseHeader.ShipDirection = ModelCollect.Address2;
            responseHeader.ShipToCode = ModelCollect.ShipToCode;
            responseHeader.VatSum = ModelCollect.VatSum;
            responseHeader.taxTotal = Number(ModelCollect.Taxes);
            responseHeader.Subtotal = Number(ModelCollect.Subtotal);
            responseHeader.U_FMB_USO_CFDI = ModelCollect.U_FMB_USO_CFDI

            for (let index = 0; index < shipAddressArray.length; index++) {
                const address = shipAddressArray[index];
                if (ModelCollect.ShipToDef === address.Address) {
                    shipAddress.Address = address.Address;
                    shipAddress.AdresType = 'S';
                    shipAddress.Block = address.Block;
                    shipAddress.City = address.City;
                    shipAddress.County = address.County;
                    shipAddress.LineNum = address.LineNum;
                    shipAddress.Street = address.Street;
                    shipAddress.ZipCode = address.ZipCode;
                }
            }
            for (let index = 0; index < billAddressArray.length; index++) {
                const address = billAddressArray[index];
                if (ModelCollect.BillToDef === address.Address) {
                    billAddress.Address = address.Address;
                    billAddress.AdresType = 'B';
                    billAddress.Block = address.Block;
                    billAddress.City = address.City;
                    billAddress.County = address.County;
                    billAddress.LineNum = address.LineNum;
                    billAddress.Street = address.Street;
                    billAddress.ZipCode = address.ZipCode;
                }
            }

            let document = []; //new PrintDocument();--DESCOMENTAR
            document.docHeader.billAddress = billAddress;
            document.docHeader.shipAddress = shipAddress;
            document.docHeader.infoByFolio = infoByFolio;
            document.docHeader.responseHeader = responseHeader;

            let ItemArray = [];
            for (let index = 0; index < ModelCollect.Items.length; index++) {
                const item = ModelCollect.Items[index];
                let newitem = []; //new ItemLine();--DESCOMENTAR
                newitem.ItemCode = item.ItemCode;
                newitem.Dscription = item.ItemName;
                newitem.Quantity = item.Quantity;
                newitem.Rate = item.TaxeRate;
                newitem.Price = item.Price;
                newitem.Total = item.Total;
                newitem.DiscountPercent = item.DiscountPercent;
                ItemArray.push(newitem);
            }
            document.docLines = ItemArray;
            await this.ShowCreatedInvoice(document, true);
        } else {
            await this.CreateDocument();
        }
    };

    ShowPDFViewer = async () => {
        await this.setState({
            showPDFViewer: !this.state.showPDFViewer,
        });
    };

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        this.setState({ PaymentSaleModel })
    };

    GetBankAccounts = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.getCuentaBancosList();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        this.setState({ BankAccounts: responseApi.data || [] })
    };

    GetCurrencies = async (docDate = this.state.ModelCollect.DocDate || moment().format('YYYY-MM-DD')) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const requestId = (this.currencyRequestId || 0) + 1;
        this.currencyRequestId = requestId;
        enableSpinner(true);
        try {
            const responseApi = await apiClient.getRateChange(docDate);
            if (requestId !== this.currencyRequestId) return false;
            if (responseApi.status !== 1) {
                this.setState({ currencys: [{ CurrCode: CURRENCY, Rate: 1 }] });
                showAlert({ type: 'error', message: responseApi.message || 'No se pudo consultar el tipo de cambio.' });
                return false;
            }
            const currencys = responseApi.data || [];
            const { ModelCollect, PaymentSaleModel } = this.state;
            if (ModelCollect.ifChangeRate && !ModelCollect.PaymentsToSale?.length) {
                const currency = currencys.find(currency => currency.CurrCode === ModelCollect.DocCur);
                const rate = Number(currency?.Rate);
                const validRate = Number.isFinite(rate) && rate > 0;
                if (!validRate) {
                    showAlert({ type: 'warning', message: `No hay tipo de cambio válido para ${ModelCollect.DocCur} el ${docDate}. Se usará ${CURRENCY}.` });
                    ModelCollect.DocCur = CURRENCY;
                    ModelCollect.ifChangeRate = false;
                }
                ModelCollect.ChangeRate = validRate ? rate : 1;
                ModelCollect.ChangeRate_1 = ModelCollect.ChangeRate;
                if (![14, 117].includes(Number(PaymentSaleModel.TypeMethod))) {
                    PaymentSaleModel.currency = Number(PaymentSaleModel.TypeMethod) === 3 && ModelCollect.DocCur === 'SOL' ? 'PEN' : ModelCollect.DocCur;
                    PaymentSaleModel.ifChangeRate = ModelCollect.ifChangeRate;
                    PaymentSaleModel.ChangeRate_1 = ModelCollect.ChangeRate_1;
                    PaymentSaleModel.total = Number(((PaymentSaleModel.totalOriginal ?? PaymentSaleModel.Amount ?? 0) / ModelCollect.ChangeRate_1).toFixed(2));
                }
            }
            this.setState({ currencys, ModelCollect, PaymentSaleModel });
            return true;
        } catch (error) {
            if (requestId !== this.currencyRequestId) return false;
            this.setState({ currencys: [{ CurrCode: CURRENCY, Rate: 1 }] });
            showAlert({ type: 'error', message: 'No se pudo consultar el tipo de cambio de la fecha seleccionada.' });
            return false;
        } finally {
            if (requestId === this.currencyRequestId) enableSpinner(false);
        }
    };
    CreateDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const {
            ModelCollect,
            idWorkShift,
            requireInvoice,
            billAddresses,
            deliveryAddresses,
            setDeliveryIndex,
            setBillIndex,
            disableRecover
        } = this.state;
        if (!ModelCollect.Items.length) {
            showAlert({ type: "warning", message: "Documento sin artículos", timeOut: 2000 });
            return;
        }

        for (let i = 0; i < ModelCollect.Items.length; i++) {
            const DocItem = ModelCollect.Items[i];
            if (DocItem.Quantity === '' || DocItem.Quantity === 0) {
                ModelCollect.Items[i].Quantity = 1;
            }
        }

        this.FillDataFromPartner();
        let table = this.selectTable(requireInvoice ? 'invoice' : ModelCollect.ObjType);
        ModelCollect.idSession = idWorkShift;
        ModelCollect.OriginDoc = 'Cobranza-CreateDocument';
        await this.IsPayedByDownPayment();
        let isUniversal = await this.CheckIfItsUniversalPartner();

        let data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: ModelCollect,
            isDraft: ModelCollect.ObjType === 'deliveries4' ? true : false,
            ItsDeliveryInvoice: (ModelCollect.ObjType === 'deliveries2' && requireInvoice) ? true : false,
            ItsRecoverDoc: disableRecover,
            ItsDeliveryDoc: (ModelCollect.ObjType === 'deliveries2' && isUniversal) ? true : false,
            Time: moment().format(),
            UserTime: moment().format("HH:mm:ss"),
            ClientVersion: currentVersion,
        };
        // return
        enableSpinner(true);
        let createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud" + createDocumentResponse.message, timeOut: 5000 });

            await this.setState({
                showBillModal: false,
            });

            return;
        }
        // $("#ticketModal").modal("show");
        let folio = createDocumentResponse.data.createdFolio;
        let document = createDocumentResponse.data.serviceLayeResponse;
        showAlert({ type: "success", message: "Gracias por tu compra: " + folio, timeOut: 5000 });

        ModelCollect.DocNum = document.DocNum;
        ModelCollect.DocTime = data.UserTime || document.DocTime;
        ModelCollect.DocEntry = document.DocEntry;
        ModelCollect.folio = folio;
        ModelCollect.NumAtCard = '';
        ModelCollect.RecoverIdSale = '';
        ModelCollect.Comments = '';
        ModelCollect.PaymentsToSale = [];
        if (data.ItsRecoverDoc) {
            ModelCollect.ItsRecoverDoc = 'Y';
        }

        if (ModelCollect.ObjType === 'deliveries4') {
            $("#refSaleModal").modal("show");
            ModelCollect.Items = [];
            ModelCollect.Total = 0;
        } else if (ModelCollect.ObjType === 'orderSales') {
            // this.ShowFormatOrderSaleModal();
            // $("#formatOrderSaleModal").modal("show");
            // do{
            //   if (showFormatOrderSaleModal===true) {
            //     ModelCollect.Items = []; 
            //     ModelCollect.Total = 0;
            //   }
            // }while (showFormatOrderSaleModal===true) 
        }

        await this.setState({
            ModelCollect,
            isCancel: false,
            disableRecover: false,
            DownPayments: [],
            CreditNotes: [],
        });

        if (requireInvoice || ModelCollect.ObjType === 'invoiceReserve') {
            $("#billModal").modal("hide");
            this.ShowCreatedInvoice(createDocumentResponse.data.createdFolio, false);
        } else if (ModelCollect.ObjType === 'deliveries') {
            $("#ticketModal").modal("show");
            this.PrintDocuments(ModelCollect.ItsRecoverDoc === "Y" ? "ComprobantePago" : "NotaCaja", "80", ModelCollect);
        } else if (ModelCollect.ObjType === 'quotations') {
            this.ShowCreatedQuotation(createDocumentResponse.data.createdFolio);
        } else if (ModelCollect.ObjType === 'orderSales') {
            this.ShowCreatedOrder(createDocumentResponse.data.createdFolio);
        } else if (ModelCollect.ObjType === 'deliveries2') {
            this.ShowCreatedDeliveryDoc(createDocumentResponse.data.createdFolio);
        } else if (ModelCollect.ObjType === 'downPayments') {
            this.ShowCreatedDownPayment(createDocumentResponse.data.createdFolio);
        }
    };

    AddPay = () => {
        this.setState({
            addingPay: !this.state.addingPay,
        });
    };

    GetDownPaymentsByPartner = async (cardCode, cardCodes) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let data = {
            CardCode: cardCode,
            CardCodes: cardCodes ?? null
        }
        enableSpinner(true);
        let responseApi = await apiClient.getDownPaymentsByPartner(data);
        enableSpinner(false);

        if (responseApi.status === 0) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }

        this.setState({
            DownPayments: responseApi.data.DownPayments || [],
            CreditNotes: responseApi.data.CreditNotes || [],
        })
    };

    CheckIfItsUniversalPartner = async () => {
        const { _user, ModelCollect } = this.state;
        let flag = true;
        if (_user?.Partner !== null && _user?.Partner !== undefined && _user?.Partner !== '') {
            if (ModelCollect.CardCode !== _user?.Partner.CardCode) {
                flag = false;
            } else {
                flag = true;
            }
        }
        await this.setState({ isUniversal: flag })
        return flag
    };

    //#region ################## POINTS CARD ################ ✔
    searchPointsCard = async newOrderModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ModelCollect } = this.state;
        enableSpinner(true);
        const getInfoCustomer = await apiClient.getOneCustomersPoints(newOrderModel.CardCode);
        // let valorPunto = await apiClient.GetAllConfiguration();

        enableSpinner(false);
        if (getInfoCustomer.status !== 1) {
            ModelCollect.flagPointsCard = false;
            this.refreshModel(ModelCollect);
            return;
        }
        // if (valorPunto.status !== 1) {
        //     showAlert({ type: "error", message: `${valorPunto.message}` });
        // }

        let points = getInfoCustomer.data[0] || '';

        ModelCollect.flagPointsCard = true;
        ModelCollect.totalPoints = points.totalPoints || 0;
        // ModelCollect.valorPunto = valorPunto.data ? (valorPunto.data[0].Point_Value || 0) : 0;

        this.refreshModel(ModelCollect);
    }
    //#endregion ################## POINTS CARD ################ ✔

    PrintDocuments = async (type, paperSize, order) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];

        for (let index = 0; index < order.Items.length; index++) {
            items[index] = {
                ItemCode: order.Items[index].ItemCode || "",
                ItemName: (order.Items[index].ItemName ? order.Items[index].ItemName : order.Items[index].ItemDescription) || "",
                Price: (order.Items[index].HomePrice ? order.Items[index].HomePrice.toString() : order.Items[index].UnitPrice) || "",
                Quantity: order.Items[index].Quantity.toString() || "",
                UM: order.Items[index].InvntryUom ? order.Items[index].InvntryUom : "" || ""
            }
        }

        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: "",
                Footer: "Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración. * Precios Sujetos a Cambio Sin Previo Aviso. ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.*** Maniobras de descarga a cargo del cliente. Toda cancelación o devolución sólo será efectiva presentando la nota y en un plazo no mayor a 7 días. Si se requiere factura, es en un plazo no mayor a 7 días, y/o en los casos que aplique, antes de cierre de mes.",
                Consecutive: ""
            },
            BusinessPartner: {
                CardCode: user.Partner.CardCode || "",
                CardName: user.Partner.CardName || "",
                RFC: user.Partner.LicTradNum || "",
                Regime: "PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL",
                Phone: user.Partner.Phone1 || "",
                AddressInvoice: "ALBARREAL #112, REAL TOLEDO. C.P.: 42185, PACHUCA, HIDALGO. MX",
                AddressDelivery: "ALBARREAL #112, REAL TOLEDO. C.P.: 42185, PACHUCA, HIDALGO. MX"
            },
            OrderSale: {
                DocNum: order.folio || "",
                DocDate: order.DocDate + " " + order.DocTime || "",
                DocOrigen: "XXXXX",
                Seller: "VENTA DE PISO",
                Cashier: user.USER_CODE || "",
                DocTotal: order.Total || "",
                Subtotal: order.Subtotal || "",
                TaxTotal: order.Taxes || "",
                TaxRate: order.TaxRate || "",
                DocCur: order.DocCur || "",
                Items: items || "",
                Payments: payments || ""
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);

    };

    //#region ########## NIUBIZ ##########
    generateQR = async (paymentInfo) => {
        const { enableSpinner, showAlert } = this.props;
        const data = {
            param: [
                { name: "transactionAmount", value: Number(paymentInfo.Amount || 0) },
                { name: "transactionCurrency", value: "604" }
            ],
        };

        enableSpinner(true)
        const apiResponse = await apiClient.generateNiubizQR(data);
        enableSpinner(false)

        if (apiResponse.status === 1) {
            paymentInfo.idNiubiz = apiResponse?.data?.tagId || "";
            paymentInfo.imageSource = apiResponse?.data?.tagImg || "";

            await this.setState({ currPayment: JSON.parse(JSON.stringify(paymentInfo)), showNiubizModal: true });
            $("#niubizModal").modal("show");
            $("#niubizModal").on("hidden.bs.modal", async () => { await this.setState({ showNiubizModal: false }); });
        } else { showAlert({ type: 'error', message: apiResponse.message || "Ocurrió un error al conectar con el servidor, vuelva a intentar en unos minutos" }); }

        return paymentInfo;
    }
    //#endregion

    // ------------------------------
    findInName(word, name) {
        let response = name.toUpperCase().includes(word)
        return (response)
    };

    DoSearch_1 = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 0; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            // if (tableReg.rows[i].classList.contains("noSearch")) {
            //     continue;
            // }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText == "") {
            lastTR.classList.add("hide");
        } else if (total) {
            // td.innerHTML="Se ha encontrado "+total+" coincidencia"+((total>1)?"s":"");
        } else {
            // lastTR.classList.add("red");
            // td.innerHTML="No se han encontrado coincidencias";
        }
    };

    ChangePaycheckNum = (value) => {
        const { PaymentSaleModel } = this.state;
        PaymentSaleModel.PaycheckNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeDatePayCheck = async (value) => {
        const { PaymentSaleModel } = this.state;
        PaymentSaleModel.DatePaycheck = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeBank = async (bankCode) => {
        const { PaymentSaleModel, BankAccounts } = this.state;
        const found = await BankAccounts.find(account => account.BankCode === bankCode);
        PaymentSaleModel.BankCode = found.BankCode;
        PaymentSaleModel.BankName = found.BankName;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeCardNum = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.CardNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeVoucherNum = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.VoucherNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeIndentification = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.Indentification = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangePhoneNum = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.PhoneNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ValidateDateCard = (value) => {
        const currentMonth = (new Date()).getMonth(); // Posibles valores (0 - 11) 
        const currentYear = (new Date()).getFullYear() % 100; // Obtener los últimos 2 dígitos del año
        const selectedMonth = (Number(value.slice(0, 2)) - 1); // Ajustar para obtener un valor valido (0 - 11) 
        const selectedYear = Number(value.slice(3, 5));
        if (selectedYear < currentYear) { return false; }
        else if (selectedMonth < currentMonth && selectedYear <= currentYear) { return false; }
        return true;
    }

    ChangeValidCard = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        value = value.replace('/', '');
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        if (value.length > 2) {
            if (value.slice(0, 2) > 12) {
                showAlert({ type: 'info', message: 'Fecha incorrecta' });
                return;
            }
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        if (value.length === 5) {
            if (!this.ValidateDateCard(value)) { showAlert({ type: 'warning', message: 'Fecha vencida' }); }
        }
        PaymentSaleModel.CardValid = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeValidateValidCard = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        if (PaymentSaleModel.CardValid.length < 5) {
            showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
            return
        }
    };

    //#region ######### CHANGE FIELDS CARDS AND DEVOLUTIONS ############################################################ 
    ChangeTransferNum = async (value) => {
        const { PaymentSaleModel } = this.state;
        PaymentSaleModel.TransferNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangePayAccountNum = async (value) => {
        const { PaymentSaleModel } = this.state;
        PaymentSaleModel.PayAccountNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeReturnFolio = async (value) => {
        const { PaymentSaleModel } = this.state;
        PaymentSaleModel.ReturnFolio = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };
    //#endregion

    //#region ######### CHANGE FIELDS DOWNPAYMENTS ############################################################ 
    ChangeDocEntryDP = async (downPay) => {
        const { PaymentSaleModel } = this.state;
        PaymentSaleModel.auxObjDP = downPay;
        PaymentSaleModel.DocEntryDP = downPay.DocEntry;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
        this.ChangeAmount(downPay.BaseAmnt);
    };
    //#endregion

    //#region ######### CHANGE FIELDS CREDITNOTES ############################################################ 
    ChangeDocEntryCN = async (creditNote) => {
        const { PaymentSaleModel, ModelCollect } = this.state;
        PaymentSaleModel.auxObjCN = creditNote;
        PaymentSaleModel.DocEntryCN = creditNote.DocEntry;
        PaymentSaleModel.currency = creditNote.DocCur || this.state.globalCurrency || CURRENCY;
        let creditNotes = ModelCollect.PaymentsToSale.length > 0 ? ModelCollect.PaymentsToSale.filter((payments) => payments.TypeMethod === '14') : [];
        PaymentSaleModel.Amount = (ModelCollect.TotalRecibido === 0 || creditNotes.length > 0) && Number(ModelCollect.RemainingAmount) <= creditNote.totalPago ? Number(ModelCollect.RemainingAmount - 0.01).toFixed(2) : Number(creditNote.totalPago).toFixed(2);
        PaymentSaleModel.Amount_1 = (ModelCollect.TotalRecibido === 0 || creditNotes.length > 0) && Number(ModelCollect.RemainingAmount) <= creditNote.totalPago ? Number(ModelCollect.RemainingAmount - 0.01).toFixed(2) : Number(creditNote.totalPago).toFixed(2);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
        // this.ChangeAmount(creditNote.totalPago);
    };
    //#endregion

    //#region ######### CHANGE PAYMENT GENERAL FIELDS ############################################################ 
    ChangeAmount = (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel } = this.state;
        if (isNaN(value) || Number(value) < 0) {
            showAlert({ type: "warning", message: `Agregue un valor valido` });
            return
        }
        if (![14, 117].includes(Number(PaymentSaleModel.TypeMethod))) {
            this.onChangeVoucher('total', value);
            PaymentSaleModel.Amount = Number((PaymentSaleModel.totalOriginal / (PaymentSaleModel.voucherBaseRate || 1)).toFixed(2));
        } else {
            PaymentSaleModel.Amount = Number(value);
        }
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeTypePayMethod = (payMethod) => {
        const { PaymentSaleModel, ModelCollect, DownPayments } = this.state;
        if (ModelCollect.DocCur === 'USD' && ![3, 14, 117].includes(Number(payMethod.type))) {
            this.props.notificationReducer.showAlert({ type: 'warning', message: 'Los pagos en USD solo admiten transferencias.' });
            return;
        }

        PaymentSaleModel.idPMBO = payMethod.idPMBO;
        PaymentSaleModel.PM_Name = payMethod.name;
        PaymentSaleModel.PM_Code = payMethod.idAPMBO;
        PaymentSaleModel.TypeMethod = payMethod.type;
        PaymentSaleModel.AcctCode = payMethod.AcctCode;
        PaymentSaleModel.PaycheckNum = '';
        PaymentSaleModel.DatePaycheck = moment(new Date()).format("YYYY-MM-DD");
        PaymentSaleModel.BankCode = '';
        PaymentSaleModel.BankName = '';

        PaymentSaleModel.CardNum = '';
        PaymentSaleModel.VoucherNum = '';
        PaymentSaleModel.Indentification = '';
        PaymentSaleModel.PhoneNum = '';

        PaymentSaleModel.TransferNum = '';
        PaymentSaleModel.PayAccountNum = '';
        PaymentSaleModel.ReturnFolio = '';
        // PaymentSaleModel.Amount = Number(0);
        PaymentSaleModel.Amount = Number(ModelCollect.RemainingAmount);
        PaymentSaleModel.Amount_1 = Number(ModelCollect.RemainingAmount);

        PaymentSaleModel.auxObjDP = {};
        PaymentSaleModel.DocEntryDP = '';
        PaymentSaleModel.AmountDP = 0;
        PaymentSaleModel.NumAtCardDP = '';
        if (PaymentSaleModel.TypeMethod == 117) {
            const taxes = [];

            let valid = true;

            for (let index = 0; index < ModelCollect.ItemsPayments.length; index++) {
                const document = ModelCollect.ItemsPayments[index];
                if (document.TaxCodeLines) {

                    const splitLines = document.TaxCodeLines.split('|');

                    if (splitLines) {

                        for (let idxSplit = 0; idxSplit < splitLines.length; idxSplit++) {

                            const line = splitLines[idxSplit];
                            const splitTax = line.split('~');

                            const taxCode = splitTax[0];
                            const taxRate = splitTax[1];

                            const exists = taxes.some(t => t.TaxCode === taxCode);

                            if (!exists) {
                                taxes.push({
                                    TaxCode: taxCode,
                                    TaxRate: taxRate
                                });
                            }
                        }

                    }

                }
            }
            ModelCollect.statusTax = 1
            if (taxes.length == 0) ModelCollect.statusTax = 'none'
            if (taxes.length > 1) {
                ModelCollect.statusTax = 'multiple'
            }
            if (taxes.length == 1) {
                for (let index = 0; index < DownPayments.length; index++) {
                    const dp = DownPayments[index];
                    if (Number(dp.VatPercent ?? 0) != Number(taxes?.[0]?.TaxRate ?? -1)) {
                        dp.Available = false
                    } else {
                        dp.Available = true
                    }
                }
            }
            ModelCollect.TaxCodeDP = taxes?.[0].TaxCode
            ModelCollect.TaxRateDP = taxes?.[0].TaxRate
            this.setState({
                ModelCollect,
                DownPayments
            })
        }

        if (![14, 117].includes(Number(PaymentSaleModel.TypeMethod))) {
            PaymentSaleModel.totalRemaining = PaymentSaleModel.Amount;
            PaymentSaleModel.currency = ModelCollect.DocCur || CURRENCY;
            if (Number(PaymentSaleModel.TypeMethod) === 3 && PaymentSaleModel.currency === 'SOL') {
                PaymentSaleModel.currency = 'PEN';
            }
            PaymentSaleModel.ChangeRate_1 = ModelCollect.ifChangeRate ? ModelCollect.ChangeRate_1 : 1;
            PaymentSaleModel.voucherBaseRate = 1;
            PaymentSaleModel.totalOriginal = PaymentSaleModel.Amount;
            PaymentSaleModel.total = Number((PaymentSaleModel.totalOriginal / PaymentSaleModel.ChangeRate_1).toFixed(2));
            PaymentSaleModel.ifChangeRate = Boolean(ModelCollect.ifChangeRate);
        } else {
            delete PaymentSaleModel.currency;
            delete PaymentSaleModel.total;
            delete PaymentSaleModel.totalOriginal;
            delete PaymentSaleModel.ChangeRate_1;
            delete PaymentSaleModel.voucherBaseRate;
            delete PaymentSaleModel.ifChangeRate;
        }

        //#region Flujo de caja
        PaymentSaleModel.CfwRlvnt = payMethod?.CfwRlvnt || null;
        PaymentSaleModel.Finanse = payMethod?.Finanse || null;

        PaymentSaleModel.transferCFWId = payMethod?.transferCFWId || null; // Para transferencias
        PaymentSaleModel.needTransferCFW = payMethod?.needTransferCFW || false; // Para transferencias
        PaymentSaleModel.transferCFWOptions = payMethod?.transferCFWOptions || []; // Para transferencias

        PaymentSaleModel.cashCFWId = payMethod?.cashCFWId || null; // Para efectivo
        PaymentSaleModel.needCashCFW = payMethod?.needCashCFW || false; // Para efectivo
        PaymentSaleModel.cashCFWOptions = payMethod?.cashCFWOptions || []; // Para efectivo

        PaymentSaleModel.checkCFWId = payMethod?.checkCFWId || null; // Para cheques
        PaymentSaleModel.needCheckCFW = payMethod?.needCheckCFW || false; // Para cheques
        PaymentSaleModel.checkCFWOptions = payMethod?.checkCFWOptions || []; // Para cheques
        //#endregion Flujo de caja

        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };
    //#endregion

    //#region ######### ADD OR REMOVE METHOD ############################################################ 

    addingPaymentSale = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel, ModelCollect, FlagPayWithSantander } = this.state;
        if (ModelCollect.DocCur === 'USD' && ![3, 14, 117].includes(Number(PaymentSaleModel.TypeMethod))) {
            showAlert({ type: 'warning', message: 'Los pagos en USD solo admiten transferencias.' });
            return;
        }
        const isSantanderCard = this.findInName("SANTANDER", PaymentSaleModel.PM_Name) ?? false;
        let auxPaymentSaleModel = new PayMethodCounter();
        if (PaymentSaleModel.Amount === '' || !Number.isFinite(Number(PaymentSaleModel.Amount)) || Number(PaymentSaleModel.Amount) <= 0) {
            showAlert({ type: "warning", message: `No es posible dejar el monto vació` });
            return
        }
        if (PaymentSaleModel.TypeMethod === '') {
            showAlert({ type: "warning", message: `No has seleccionado un método de pago` });
            return
        }
        switch (Number(PaymentSaleModel.TypeMethod)) {
            case 1: // checks
                if (PaymentSaleModel.PaycheckNum === '') {
                    showAlert({ type: "warning", message: `El campo de cheque esta vació` });
                    return
                }
                if (PaymentSaleModel.BankCode === '') {
                    showAlert({ type: "warning", message: `No has seleccionado un banco para el pago con cheque` });
                    return
                }
                //#region Flujo de caja
                if (Sections['FlujoCaja'] && PaymentSaleModel?.needCheckCFW && !PaymentSaleModel?.checkCFWId && false) { // Este se queda comentado por que en sap no se muestra visualmente
                    showAlert({ type: "warning", message: `Por favor especifique el "Flujo de caja" para cheques`, timeOut: 5000 });
                    return
                }
                //#endregion Flujo de caja
                break;
            case 2: //credit cards
                if (!FlagPayWithSantander || !isSantanderCard) {
                    if (PaymentSaleModel.CardNum === '') {
                        showAlert({ type: "warning", message: `El número de tarjeta esta vació` });
                        return
                    }
                    if (PaymentSaleModel.VoucherNum === '') {
                        showAlert({ type: "warning", message: `El número de autorización esta vació` });
                        return
                    }
                    if (PaymentSaleModel.CardValid.length < 5) {
                        showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
                        return
                    } else if (!this.ValidateDateCard(PaymentSaleModel.CardValid)) {
                        showAlert({ type: 'warning', message: 'Fecha vencida' });
                        return
                    }
                } else {
                    this.LaunchPaymentWithTerminalQuestion();
                    return;
                }


                break;
            case 3://transfers
                if (PaymentSaleModel.TransferNum === '') {
                    showAlert({ type: "warning", message: `El número de transferencia esta vació` });
                    return
                }
                if (PaymentSaleModel.PayAccountNum === '') {
                    showAlert({ type: "warning", message: `El número de cuenta de pago esta vació` });
                    return
                }
                // if (ModelCollect.PaymentsToSale && Array.isArray(ModelCollect.PaymentsToSale)) {
                //     const hasTransferAdded = ModelCollect.PaymentsToSale.find(element => Number(element.TypeMethod) === 3);
                //     if (hasTransferAdded !== undefined) {
                //         showAlert({ type: "info", message: `No es posible agregar mas 1 transferencia por movimiento de pago` });
                //         return
                //     }
                // }
                //#region Flujo de caja
                if (Sections['FlujoCaja'] && PaymentSaleModel?.needTransferCFW && !PaymentSaleModel?.transferCFWId) {
                    showAlert({ type: "warning", message: `Por favor especifique el "Flujo de caja" para transferencia`, timeOut: 5000 });
                    return
                }
                //#endregion Flujo de caja
                break;
            case 4://devolution
                if (PaymentSaleModel.ReturnFolio === '') {
                    showAlert({ type: "warning", message: `El folio esta vació` });
                    return
                }
                break;
            case 117://facturas de anticipo
                if (Number(PaymentSaleModel.Amount) > PaymentSaleModel.auxObjDP.DocTotal) {
                    showAlert({ type: "error", message: `No puedes aumentar el valor de una factura registrada` });
                    return
                }
                PaymentSaleModel.PM_Name += ' - ' + PaymentSaleModel.auxObjDP.NumAtCard;
                PaymentSaleModel.AmountDP = Number(PaymentSaleModel.Amount);
                break;
            case 125: // NIUBIZ
                const qrResponse = await this.generateQR(PaymentSaleModel);

                if (!qrResponse.imageSource) return;
                PaymentSaleModel.idNiubiz = qrResponse.idNiubiz || "";
                PaymentSaleModel.imageSource = qrResponse.imageSource || "";
                break;
            case 0:
                //#region Flujo de caja
                if (Sections['FlujoCaja'] && PaymentSaleModel?.needCashCFW && !PaymentSaleModel?.cashCFWId) {
                    showAlert({ type: "warning", message: `Por favor especifique el "Flujo de caja" para efectivo`, timeOut: 5000 });
                    return
                }
                //#endregion Flujo de caja
                break;

            default:
                break;
        }

        if (Number(PaymentSaleModel.TypeMethod) === 124) {
            PaymentSaleModel.TransferNum = PaymentSaleModel.U_FMB_FISE_COD || '';
        }

        if (needTransferReference(PaymentSaleModel, true)) {
            showAlert({ type: "warning", message: `Debe especificar una referencia${PaymentSaleModel.PM_Name ? ` para la forma de pago "${PaymentSaleModel.PM_Name}"` : ''}.`, timeOut: 8000 });
            return
        }

        let newArray = ModelCollect.PaymentsToSale;

        newArray.push(PaymentSaleModel);

        ModelCollect.PaymentsToSale = newArray;
        await this.RefreshOrder(ModelCollect);
        this.RefreshPaymentSaleModel(auxPaymentSaleModel);
        if (Number(PaymentSaleModel.TypeMethod) === 117) {
            await this.AffectSubTotal(PaymentSaleModel.AmountDP);
        }
        this.SumOfAmounts();
        this.AddPay();
    };

    RemovePaymentSale = async (index) => {
        const { ModelCollect } = this.state;
        let newArray = ModelCollect.PaymentsToSale;
        newArray.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        ModelCollect.PaymentsToSale = newArray;
        await this.RefreshOrder(ModelCollect);
        this.SumOfAmounts();
    };

    RemovePaymentSaleByNiubiz = async (idNiubiz = '') => {
        const { ModelCollect } = this.state;
        let newArray = ModelCollect.PaymentsToSale.filter(element => element.idNiubiz !== idNiubiz);
        ModelCollect.PaymentsToSale = newArray;
        await this.RefreshOrder(ModelCollect);
        this.SumOfAmounts();
    };

    addNiubizReference = async (idNiubiz = '', NiubizReference = '') => {
        const { ModelCollect } = this.state;
        if (!idNiubiz || !NiubizReference) return;

        ModelCollect.PaymentsToSale = ModelCollect.PaymentsToSale.map(element => {
            if (element.idNiubiz === idNiubiz) {
                return {
                    ...element,
                    TransferNum: NiubizReference || ''
                };
            }
            return element;
        });

        await this.RefreshOrder(ModelCollect);
        this.SumOfAmounts();
    };
    //#endregion

    SumOfAmounts = async () => {
        const { ModelCollect, PaymentSaleModel } = this.state;
        let totalAmount = 0;
        for (const payAdded of ModelCollect.PaymentsToSale) {
            if (Number(payAdded.TypeMethod) !== 117) {
                if (payAdded.currentCheck) {//SOLO VOUCHERS CON REDONDEO
                    totalAmount = totalAmount + Number(payAdded.totalRemaining);
                } else {
                    totalAmount = totalAmount + Number(payAdded.Amount);
                }
            }
        }

        ModelCollect.TotalRecibido = totalAmount;
        ModelCollect.TotalRestante = totalAmount ? (totalAmount - ModelCollect.totalPago) > 0 ? totalAmount - ModelCollect.totalPago : 0 : 0;

        ModelCollect.RemainingAmount = parseFloat(Number(ModelCollect.totalPago) - Number(totalAmount)).toFixed(2);
        PaymentSaleModel.Amount = Number(ModelCollect.RemainingAmount)
        PaymentSaleModel.Amount_1 = Number(ModelCollect.RemainingAmount)
        if (![14, 117].includes(Number(PaymentSaleModel.TypeMethod))) {
            PaymentSaleModel.currency = ModelCollect.DocCur || CURRENCY;
            if (Number(PaymentSaleModel.TypeMethod) === 3 && PaymentSaleModel.currency === 'SOL') {
                PaymentSaleModel.currency = 'PEN';
            }
            PaymentSaleModel.ChangeRate_1 = ModelCollect.ifChangeRate ? ModelCollect.ChangeRate_1 : 1;
            PaymentSaleModel.ifChangeRate = Boolean(ModelCollect.ifChangeRate);
            PaymentSaleModel.voucherBaseRate = 1;
            PaymentSaleModel.totalOriginal = PaymentSaleModel.Amount;
            PaymentSaleModel.total = Number((PaymentSaleModel.Amount / PaymentSaleModel.ChangeRate_1).toFixed(2));
            PaymentSaleModel.totalRemaining = PaymentSaleModel.Amount;
        }

        //#region CREDIT PERCEPTIONS
        const hasPerceptions = ModelCollect.ItemsPayments?.some(row => Number(row.U_PRC_IMP) > 0);
        ModelCollect.U_BPP_MDTDPaymentDefault = hasPerceptions ? ModelCollect.U_BPP_MDTDPaymentDefault : null;
        ModelCollect.U_BPP_PTSCPaymentDefault = hasPerceptions ? ModelCollect.U_BPP_PTSCPaymentDefault : null;
        //#endregion CREDIT PERCEPTIONS

        await this.RefreshOrder(ModelCollect);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    AffectSubTotal = async (AmountDP) => {
        const { ModelCollect } = this.state;
        let SubTotal = parseFloat((Number(ModelCollect.totalPago) / (1 + (ModelCollect.TaxRate / 100))) - Number(AmountDP)).toFixed(2);
        let Taxes = parseFloat(Number(SubTotal) * (ModelCollect.TaxRate / 100)).toFixed(2);
        ModelCollect.Subtotal = Number(SubTotal);
        ModelCollect.Taxes = Number(Taxes);
        ModelCollect.totalPago = parseFloat(Number(ModelCollect.Subtotal) + Number(ModelCollect.Taxes)).toFixed(2)

        await this.RefreshOrder(ModelCollect);
    }
    //#endregion --------PAGOS--------

    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);
        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                if (responseApi.data.NotCashCut === true) {
                    showAlert({ type: "info", message: `${responseApi.message}. Realiza tu corte para continuar`, timeout: 10000 });
                    await this.setState({
                        idWorkShift: responseApi.data.idSession,
                        lastDaySession: true,
                    });
                    await this.ShowCashCutModal();
                    $("#cashCutModal").modal("show");
                } else {
                    this.setState({ idWorkShift: responseApi.data.idSession });
                }
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    ShowInitialCash = async () => {
        await this.setState({
            showInitialCashModal: !this.state.showInitialCashModal,
        });

        $("#initialCashModal").modal("show");
    };

    ShowCashCutModal = async () => {
        await this.setState({
            showCashCutModal: !this.state.showCashCutModal,
        });
        if (this.state.showCashCutModal) await this.GetBoxCut();
    };

    //#region ########## CASH CUT #########################################################
    GetBoxCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        enableSpinner(true);
        let responseApi = await apiClient.partialCut(idWorkShift);

        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        await this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            TotalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries
        });
    };

    CloseWorkShift = async (blindInfoModel) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        const data = {
            idWorkShift,
            blindInfoModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.closeWorkShiftT(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });

            return false;
        }
        showAlert({ type: "info", message: `${responseApi.message}` });
        $("#totalModal").modal("show");
        await this.setState({
            lastDaySession: false,
            ReturnedBlindCut: responseApi.ReturnedBlindCut || [],
        })
        return true;
    };
    //#endregion

    InsertWorkShiftT = async () => {
        const {
            enableSpinner,
            notificationReducer: { showAlert },
        } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.insertWorkShiftT();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        if (responseApi.status === 0) {
            this.GotoDashboard();
        }
        this.setState({ idWorkShift: responseApi.data.idSession });
    };

    CancelWorkShift = () => {
        this.GotoDashboard();
    };

    GotoDashboard = () => {
        this.props.history.push("/");
    };

    SendToLogin = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        showAlert({ type: "info", message: `ESTAS SIENDO REDIRIGIDO AL LOGIN. ESTO ES PLANEADO.`, timeOut: 99999 });
        localStorage.removeItem(config.localStorageNamed + 'Token');
        localStorage.removeItem(config.localStorageNamed + 'currentUser');
        localStorage.removeItem(config.localStorageNamed + 'toogleNavBarItem');
        // const existStorage = localStorage.getItem(config.localStorageNamed + 'currentUser');
        socketService.emit('logout', '');
        this.props.history.push('/');
        this.props.history.push('/login');
        window.location.reload(true);

    }

    //#region ########## MAIL FUNCTIONS  #################################################
    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    };

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    };

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state;
        sendMailModel.docEntry = docsToPrint[0].header.DocEntry;

        let data = {
            sendMailModel,
            typeDoc: 'ORCT',
            objType: 24,
            infoDoc: [{
                cardCode: docsToPrint[0].header.CardCode ?? '',
                folio: docsToPrint[0].header.folio ?? '',
                docEntry: docsToPrint[0].header.DocEntry ?? '',
                slpInfo: {
                    slpCode: !!docsToPrint[0].header ? !!docsToPrint[0].header.responseHeader && !!docsToPrint[0].header.responseHeader.SlpCode !== undefined && docsToPrint[0].header.responseHeader.SlpCode : !!docsToPrint[0].docHeader.SlpCode !== undefined && docsToPrint[0].docHeader.SlpCode || '',
                    slpName: !!docsToPrint[0].header ? !!docsToPrint[0].header.responseHeader && !!docsToPrint[0].header.responseHeader.SlpName !== undefined && docsToPrint[0].header.responseHeader.SlpName : !!docsToPrint[0].docHeader.SlpName !== undefined && docsToPrint[0].docHeader.SlpName || '',
                }
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    };
    //#endregion

    CloseCreatedInvoiceActions = async () => {
        let { newOrderModel, isCancel, _user } = this.state;
        let partner = _user?.Partner;
        newOrderModel = new NewOrderSales();
        newOrderModel.TaxCode = partner.TaxCode;
        newOrderModel.TaxName = partner.TaxName;
        newOrderModel.TaxRate = partner.Rate;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.PriceListNum = partner.ListNum;
        newOrderModel.ShipToDef = partner.ShipToDef;
        newOrderModel.BillToDef = partner.BillToDef;
        newOrderModel.ObjType = 'deliveries';

        await this.ShowPDFViewer();
        await this.setState({
            newOrderModel,
            docsToPrint: [],
            typeDocPrint: '',
            ordersToAction: 0,
            requireInvoice: false,
            itemSelected: {},
            showBillModal: isCancel || !this.state.showBillModal,
        })

    };

    RefreshDocModel = async (EditableDocModel) => {
        await this.setState({ EditableDocModel })
    };

    SaveChangesInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { EditableDocModel, ordersToAction } = this.state
        let data = { EditableDocModel, ordersToAction }
        enableSpinner(true)
        let responseApi = await apiClient.SaveChangesOrderInvoice(data);
        enableSpinner(false)
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `DOCUMENTO Y SOCIO ACTUALIZADOS CORRECTAMENTE` });
        this.ChangeEditableMode()
        await this.setState({ docsToPrint: responseApi.data ?? [] });
    };

    UploadInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ordersToAction, idWorkShift, pedido, newOrderModel } = this.state

        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido)
        let data = {
            ordersToAction,
            infoFolio,
            idWorkShift,
            newOrderModel,
            Folio: pedido
        }

        enableSpinner(true);
        let responseApi = await apiClient.createInvoiceCounter(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message}`, timeOut: 10000 });
        await this.CloseRefundModal()
        $("#salesModal").modal("hide");
        this.ShowCreatedInvoice(responseApi.data.createdFolio, false);
    };

    ShowCreatedPayment = async (document, beforeEdit, documents, timbraResponse) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!beforeEdit) {
            enableSpinner(true);
            let data = {
                doc: document.substring(5, 50),
                table: 'ORCT',
                docSubType: "--",
                view: "payment",
                view2: "payment"
            };
            enableSpinner(true);
            let responseApi = await apiClient.getDocumentsDetails(data);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                this.CloseCreatedInvoiceActions();
                return;
            }

            if (timbraResponse && timbraResponse.status) {
                showAlert({ type: "success", message: `${timbraResponse.message}` });
                responseApi.data.header.U_FMB_XMLTIMBRA = JSON.stringify(timbraResponse.XML);
            } else if (timbraResponse && !timbraResponse.status) {
                showAlert({ type: "error", message: `Documento no timbrado` });
                showAlert({ type: "info", message: `${timbraResponse.message}`, timeOut: 10000 });
            }

            let lineas = [];
            for (let index = 0; index < documents.length; index++) {
                const element = documents[index];

                let docsToPrintIds = [];
                docsToPrintIds.push('00000' + element.DocEntry);
                let data = {
                    docsToPrintIds,
                    typeDoc: 13
                }
                let response = await apiClient.getPrintDocsInfo(data);
                if (response.status === 1) {
                    lineas.push(response.data[0].docHeader.responseHeader)
                }
            }
            enableSpinner(false);

            responseApi.data.header.folio = document;
            responseApi.data.items = lineas;
            let docs = [responseApi.data];
            await this.setState({
                docsToPrint: docs ?? [],
                typeDocPrint: 'OINV', ordersToAction: document, EnableEditButton: false, showPDFViewer: !this.state.showPDFViewer,
            });
            $("#pdfViewer").modal("show");

        } else {
            await this.setState({ docsToPrint: [document] ?? [], typeDocPrint: 'OINV', ordersToAction: '' });
            await this.ShowPDFViewer();
            $("#pdfViewer").modal("show");
        }
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    ChangeTaxFilter = async (filterTax) => {
        const { dataInvoice, dataInvoiceCopy } = this.state
        if (dataInvoice.length === 0) return

        if (Number(filterTax) === 0) {
            await this.setState({
                dataInvoice: dataInvoiceCopy,
            })
        } else {
            const withTaxParameter = dataInvoiceCopy?.filter((element) => Number(element.PrcntTax) === Number(filterTax));
            await this.setState({
                dataInvoice: (Number(filterTax) !== 0) ? withTaxParameter : dataInvoiceCopy,
            })
        }
    }

    //#region ########## PAY WITH TERMINAL METHODS #################################################
    DeterminatePayWithTerminalPermission = async () => {
        const { _user } = this.state
        let flag = false;
        if (_user?.M_user !== "" || _user?.M_pass !== "") {
            flag = true;
        }

        await this.setState({
            FlagPayWithSantander: flag
        })
    }

    CheckTerminalConnection = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state

        if (_user?.M_user === "" || _user?.M_pass === "") {
            showAlert({ type: 'error', message: "TU USUARIO NO ES VALIDO PARA PAGAR CON TARJETA, CONTACTA CON TU ADMINISTRADOR PARA HABILITAR ESTA OPCION.", timeOut: 8000 });
            return;
        }

        const data = {
            test_enviroment: development,
            product: "Counter",
            data: {
                user: _user.M_user, // 9249INUA29
                password: _user.M_pass, // H5ZJAXT1HV
                salesAmount: '0.0',
                userTransaction: (_user?.U_NAME ?? '').substring(0, 30) ?? "--"
            }
        };
        enableSpinner(true);
        const checkConnection = await apiClient.CheckConnection(data);
        enableSpinner(false);
        //$("#terminalFunctions").modal("show");
        if (Number(checkConnection.status) !== 1) {
            showAlert({ type: 'error', message: checkConnection.message, timeOut: 5000 });
            return;
        }

        showAlert({ type: 'success', message: checkConnection.message, timeOut: 5000 });
        const auxMessage = `${checkConnection.data.TerminalEMVFull ?? ""}\n ${checkConnection.data.TerminalVersion ?? ""}\n ${checkConnection.data.TerminalPrinter ?? ""}`;
        showAlert({ type: 'info', message: auxMessage, timeOut: 8000 });
        // $("#terminalFunctions").modal("show"); // administrative functions terminal

    }

    LaunchPaymentWithTerminalQuestion = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        $("#collectionModal").modal("hide");
        $("#collectModal").modal("hide");
        $("#vmPayWithTerminal").modal("show");
        showAlert({ type: "info", message: "Hemos detectado que seleccionaste tarjeta como método de pago.", timeOut: 5000 });
    }

    CancelPayWithTerminal = () => {
        const { notificationReducer: { showAlert } } = this.props;

        showAlert({ type: "info", message: "Seleccionaste NO pagar con tarjeta, debes de seleccionar métodos de pago distintos a tarjeta para continuar", timeOut: 8000 });
        $("#vmPayWithTerminal").modal("hide");
        $("#collectModal").modal("show");
        $("#collectionModal").modal("show");

    }

    PayWithCreditTerminal = async () => {
        const { ModelCollect, PaymentSaleModel, _user } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (_user?.M_user === "" || _user?.M_pass === "") {
            showAlert({ type: 'error', message: "TU USUARIO NO ES VALIDO PARA PAGAR CON TARJETA, CONTACTA CON TU ADMINISTRADOR PARA HABILITAR ESTA OPCION.", timeOut: 8000 });
            return;
        }
        if (PaymentSaleModel.Amount === "" || Number(PaymentSaleModel.Amount) === 0) {
            showAlert({ type: 'error', message: "La cantidad a cobrar se registro en 0, esto es imposible reinicia el proceso de cobro del documento para continuar con el cobro por terminal.", timeOut: 8000 });
            return;
        }

        const data = {
            test_enviroment: development,
            product: "Counter",
            data: {
                user: _user.M_user,
                password: _user.M_pass,
                salesAmount: PaymentSaleModel.Amount,
                userTransaction: (_user?.U_NAME ?? '').substring(0, 30) ?? "--"
            }
        };

        enableSpinner(true);
        const payWithTerminal = await apiClient.PayWithCreditTerminal(data);
        enableSpinner(false);

        if (Number(payWithTerminal.status) !== 1) {
            showAlert({ type: 'error', message: payWithTerminal.message, timeOut: 8000 });
            $("#collectModal").modal("show");
            $("#collectionModal").modal("show");
            return;
        }

        showAlert({ type: 'success', message: payWithTerminal.message, timeOut: 8000 });

        // if the pay was successfully it payment added to payments to sale
        let newArray = ModelCollect.PaymentsToSale;
        PaymentSaleModel.SuccessTerminal = true;
        newArray.push(PaymentSaleModel);
        ModelCollect.PaymentsToSale = newArray;
        await this.refreshModel(ModelCollect); // it was put here because this.SumOfAmounts will be use newOrderModel
        this.RefreshPaymentSaleModel(new PayMethodCounter());
        await this.SumOfAmounts();
        this.AddPay();


        // that fields are mine
        const payTerminalInfo = await this.FillCardInfoPayment(payWithTerminal.data);
        ModelCollect.flagPayWithTerminal = true;
        ModelCollect.payWithTerminalInfo.push(payTerminalInfo);
        await this.refreshModel(ModelCollect);
        $("#collectModal").modal("show");
        $("#collectionModal").modal("show");
        await this.PrintVoucherMIT(null, await this.ReorganiceVoucher(payWithTerminal.data.VoucherCliente), "voucherCliente");
        await this.PrintVoucherMIT(null, await this.ReorganiceVoucher(payWithTerminal.data.VoucherComercio), "voucherComercio");
    }

    PrintVoucherMIT = async (objectToPrint, voucherArray, typeVoucher) => {
        const user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        const data = {
            Config: {
                TicketType: typeVoucher,
                PaperSize: "50"
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: (user?.Branch?.Address ?? '').substring(0, 70) || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: development === true ? ImageVoucherMIT_dev : ImageVoucherMIT_prod,
                Footer: `ESTE ES UN VOUCHER VALIDO ${development ? 'DE PRUEBAS' : ''} GENERADO POR LA TRANSACCIÓN ANTES MOSTRADA. CUALQUIER DEVOLUCIÓN DEBE DE SER SOLICITADA EL DIA DE EXPEDICIÓN DE ESTA TRANSACCIÓN ANTES DE LAS 11 DE LA NOCHE HORA CDMX, DE LO CONTRARIO NO SERA POSIBLE GENERAR LA DEVOLUCIÓN/CANCELACIÓN DE ESTA TRANSACCIÓN`,
            },
            Document: objectToPrint ?? null,
            Voucher: voucherArray ?? []

        }
        await apiClient.PrintVouchersMIT(data);
    };

    ReorganiceVoucher = (voucherInfo) => {
        const arrayInfoVoucher = [];
        const notDesireWords = ["@lsn", "@br", "@bc", "@cnb", "@lnn", "@cnn"];
        // Crea una expresión regular que coincida con cualquiera de las palabras no deseadas
        const regex = new RegExp(notDesireWords.join("|"), "gi");

        // Reemplaza todas las ocurrencias de las palabras no deseadas con una cadena vacía
        const nuevoTexto = voucherInfo.replace(regex, "");

        const newArray = nuevoTexto.split('\n');
        newArray.forEach(linea => {
            if (linea !== " ") arrayInfoVoucher.push(linea);
        });

        return arrayInfoVoucher;
    }

    FillCardInfoPayment = (response) => {
        let model = new PaymentCardsInfo();

        model.statusOp = response?.statusOp ?? "";
        model.NOperacion = response?.NOperacion ?? "";
        model.NAutorizacion = response?.NAutorizacion ?? "";
        model.CDResp = response?.CDResp ?? "";
        model.Ref = response?.Ref ?? "";
        model.Arqc = response?.Arqc ?? "";
        model.Aid = response?.Aid ?? "";
        model.AidLabel = response?.AidLabel ?? "";
        model.getRspDsOperationType = response?.getRspDsOperationType ?? "";

        return model;
    }

    //#endregion


    //#region ########## OXXO REFERENCES METHODS #################################################
    UpdateStateField = async (key, event) => {
        let value = event.target.value ?? '';
        await this.setState({
            [key]: value
        })
    }

    ChangeOxxoRefField = async (key, event) => {
        let value = event.target.value ?? '';
        await this.setState({
            [key]: value,
            cliente: '',

        })
    }
    //#endregion
    refreshSearch = (searchData) => {
        this.setState({
            searchData
        })
    }
    searchPayments = () => {

    }

    searchCollectDoc = () => {
        this.CargarDatos();
    }

    handleChangeFechaInicio = (e) => {
        const value = e.target.value;

        this.setState({
            dateInit: value
        });
    };

    handleChangeFechaFin = (e) => {
        const value = e.target.value;

        this.setState({
            dateFinal: value
        });
    };

    handleBlurFechaInicio = () => {
        const { dateInit, dateFinal, TODAY } = this.state;

        let newDateInit = dateInit;

        if (!dateInit) {
            newDateInit = TODAY;
        } else {
            const inicio = new Date(dateInit);

            if (isNaN(inicio.getTime())) {
                newDateInit = TODAY;
            } else if (dateFinal) {
                const fin = new Date(dateFinal);
                if (inicio > fin) {
                    newDateInit = dateFinal;
                }
            }
        }

        if (newDateInit !== dateInit) {
            this.setState({ dateInit: newDateInit });
        }
        this.setState({ isNewSearch: true, selectedSeries: [], seriesOptions: [] });
    };
    handleBlurFechaFin = () => {
        const { dateInit, dateFinal, TODAY } = this.state;

        let newDateFinal = dateFinal;

        if (!dateFinal) {
            newDateFinal = TODAY;
        } else {
            const fin = new Date(dateFinal);

            if (isNaN(fin.getTime())) {
                newDateFinal = TODAY;
            } else if (dateInit) {
                const inicio = new Date(dateInit);
                if (fin < inicio) {
                    newDateFinal = dateInit;
                }
            }
        }

        if (newDateFinal !== dateFinal) {
            this.setState({ dateFinal: newDateFinal });
        }
        this.setState({ isNewSearch: true, selectedSeries: [], seriesOptions: [] });
    };

    handleAllSN = (e) => {
        const checked = e.target.checked;

        this.setState((prevState) => ({
            allSN: checked,
            cliente: checked ? '' : prevState.cliente,

            ModelCollect: {
                ...prevState.ModelCollect,

                CardCode: checked ? '' : prevState.ModelCollect.CardCode,
                CardName: checked ? '' : prevState.ModelCollect.CardName,
                U_FMB_AUX_CARDNAME: checked ? '' : prevState.ModelCollect.U_FMB_AUX_CARDNAME,
                BpAct: checked ? '' : prevState.ModelCollect.BpAct,
                BpActName: checked ? '' : prevState.ModelCollect.BpActName,
                BpActFormatCode: checked ? '' : prevState.ModelCollect.BpActFormatCode,
                BpActCopy: checked ? '' : prevState.ModelCollect.BpActCopy,
                BpActNameCopy: checked ? '' : prevState.ModelCollect.BpActNameCopy,
                BpActFormatCodeCopy: checked ? '' : prevState.ModelCollect.BpActFormatCodeCopy,
                Address: checked ? '' : prevState.ModelCollect.Address
            }
        }));
    };

    extractSerie = (text) => {
        if (!text) return null;

        const match = text?.match(/-([FB][A-Z0-9]+)-/i);
        return match ? match[1].toUpperCase() : null;
    };

    showMultiplePaymentsSummary = () => {
        $("#multiplePaymentsSummaryModal").modal("show");
    };

    closeMultiplePaymentsSummary = () => {
        const { ModelCollect, multiplePaymentsSummary = [] } = this.state;
        if (multiplePaymentsSummary?.some(summary => summary.status === 'success')) { // Se creo al menos uno
            $("#multiplePaymentsSummaryModal").modal("hide");
            $('#collectionModal').modal('hide');
            $('#collectModal').modal('hide');

            setTimeout(() => {
                ModelCollect.SerieCode = '';
                ModelCollect.CashAcct = '';
                ModelCollect.CashAcctFormatCode = '';
                ModelCollect.CashSum = '';
                ModelCollect.ItemsPayments = [];
                ModelCollect.PaymentsCreditCards = [];
                ModelCollect.CreditSum = '';
                ModelCollect.PaymentsToSale = [];
                ModelCollect.flagPointsCard = false;

                setTimeout(() => {
                    this.setState({
                        ModelCollect,
                        ShowPaymentModal: !this.state.ShowPaymentModal,
                        ShowCheckListModal: false,
                        showCollectModalModal: false,
                        ShowPaymentCreditCardsModal: false,
                        multiplePaymentsSummary: [],
                        multiplePerceptions: [],
                        isSameSerie: false,
                        perceptionsConfirmed: false,
                        modelsByClientPending: [],
                    }, () => {
                        this.CargarDatos();
                    });
                }, 100);

            }, 500);
        } else { // No se creo ningún pago
            $("#multiplePaymentsSummaryModal").modal("hide");
        }
    };

    handleIsSameSerie = () => {
        this.setState((prevState) => {
            const newValue = !prevState.isSameSerie;

            let newPerceptions = [...prevState.multiplePerceptions];

            if (newValue) {
                const firstValue = newPerceptions?.[0]?.U_BPP_PTSCPaymentDefault || '';

                newPerceptions = newPerceptions.map(p => ({
                    ...p,
                    U_BPP_PTSCPaymentDefault: firstValue
                }));
            }

            return {
                isSameSerie: newValue,
                multiplePerceptions: newPerceptions
            };
        });
    };

    handleSerieChange = (value, index) => {
        const newValue = (value || '').slice(0, 4);

        this.setState((prevState) => {
            let newPerceptions = [...prevState.multiplePerceptions];

            if (prevState.isSameSerie) {
                newPerceptions = newPerceptions.map(p => ({
                    ...p,
                    U_BPP_PTSCPaymentDefault: newValue
                }));
            } else {
                newPerceptions[index] = {
                    ...newPerceptions[index],
                    U_BPP_PTSCPaymentDefault: newValue
                };
            }

            return {
                multiplePerceptions: newPerceptions
            };
        });
    };

    handleConfirmPerceptions = () => {
        const { multiplePerceptions } = this.state;
        const { notificationReducer: { showAlert } } = this.props;

        if (multiplePerceptions.some(p => !p.U_BPP_PTSCPaymentDefault)) {
            showAlert({ type: 'warning', timeOut: 5000, message: `Es necesario completar la información de "Serie del documento" para todos los socios` });
            return;
        }

        this.setState({
            perceptionsConfirmed: true
        }, () => {
            $("#multiplePerceptionsModal").modal("hide");
            this.Abonar();
        });
    };

    goBackPerceptions = () => {
        $("#multiplePerceptionsModal").modal("hide");
    }

    validateVoucher = async () => {
        const { ModelCollect, PaymentSaleModel, toleranceInfo = [] } = this.state;
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const voucherRound = ModelCollect.PaymentsToSale?.find((payment) => Number(payment.TypeMethod) === 3 && payment.currentCheck);
        if (voucherRound) {
            return showAlert({ type: "warning", message: "Solo puedes usar 1 voucher con redondeo" });
        }
        if (!PaymentSaleModel.number) { return showAlert({ type: "warning", message: "Ingrese un Numero de movimiento valido" }); }
        if (!PaymentSaleModel.bank) { return showAlert({ type: "warning", message: "Ingrese un Banco valido" }); }
        if (!moment(PaymentSaleModel.date || "").isValid()) { return showAlert({ type: "warning", message: "Ingrese una fecha valida" }); }
        if (!PaymentSaleModel.currency) { return showAlert({ type: "warning", message: "Ingrese una moneda valida" }); }
        if (!Number(`${PaymentSaleModel.total || 0}`.replace(/,/g, ""))) { return showAlert({ type: "warning", message: "Ingrese un Total valido" }); }

        const hasOldDocs = PaymentSaleModel.date && moment().diff(moment(PaymentSaleModel.date), 'days') > 3;
        if (hasOldDocs && !PaymentSaleModel.U_RS_CODAPR) { return showAlert({ type: "warning", message: "No puede registrar cobros de documentos con más de 3 días de antigüedad. Ingrese un código de aprobación." }); }
        //#region VALIDACIÓN REDONDEO
        if (PaymentSaleModel.currentCheck) {
            const round2 = (value) =>
                Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
            const total = Number(PaymentSaleModel.totalOriginal ?? 0) / (PaymentSaleModel.voucherBaseRate || 1);
            const remaining = Number(PaymentSaleModel?.totalRemaining ?? 0) -
                Number(total)
            const restante = round2(
                remaining
            );
            const currency = ModelCollect?.ItemsPayments?.DocCur || CURRENCY;
            const currentTolerance = toleranceInfo?.find(t => (t.CurrCode === currency) || (t.DocCurrCod === currency) || (t.ISOCurrCod === currency)) ?? {};
            const TOLERANCE = restante > 0
                ? Number(currentTolerance?.MaxOutDiff ?? 0) // Falta
                : Number(currentTolerance?.MaxInDiff ?? 0); // Sobra
            if (Math.abs(restante) > TOLERANCE) {

                return showAlert({
                    type: "warning",
                    message: `El depósito supera la tolerancia permitida. Restante: ${(Math.abs(restante))}`
                });

            }
        }
        //#endregion

        enableSpinner(true)
        const apiResponse = await apiClient.validateVoucher({ voucher: PaymentSaleModel });
        enableSpinner(false)
        if (apiResponse.status !== SERVICE_RESPONSE.SUCCESS) {
            return showAlert({ type: "error", message: apiResponse.message || "Error al conectar con el servidor, intente más tarde" });
        }

        this.RefreshPaymentSaleModel(PaymentSaleModel);
        const findVoucher = ModelCollect.PaymentsToSale?.find((payment) => // El quiebre es por todos los siguientes datos, ya que un número de referencia con el mismo monto, moneda y banco puede estar en 2 depositos pero con fechas diferentes
            Number(payment.TypeMethod) === 3 &&
            payment.PayAccountNum === PaymentSaleModel.number &&
            payment.bank === PaymentSaleModel.bank &&
            moment(payment.date).format("YYYY-MM-DD") === moment(PaymentSaleModel.date).format("YYYY-MM-DD") &&
            payment.currency === PaymentSaleModel.currency &&
            parseFloat(String(payment.total ?? 0).replace(/,/g, '')) === parseFloat(String(PaymentSaleModel.total ?? 0).replace(/,/g, ''))
        );
        if (findVoucher) {
            return showAlert({ type: "error", message: 'Ya estas usando este voucher' });
        } else {
            PaymentSaleModel.PayAccountNum = PaymentSaleModel.number
            PaymentSaleModel.Amount = Number((PaymentSaleModel.totalOriginal / (PaymentSaleModel.voucherBaseRate || 1)).toFixed(2));
            await this.addingPaymentSale()
        }
    };

    GetVoucherCurrencyRate = (currencyCode) => {
        if (currencyCode === CURRENCY || (CURRENCY === 'SOL' && currencyCode === 'PEN')) return 1;
        const currency = this.state.currencys.find(currency => currency.CurrCode === currencyCode);
        const rate = Number(currency?.Rate);
        return Number.isFinite(rate) && rate > 0 ? rate : null;
    };

    onChangeVoucher = (key, value) => {
        const { PaymentSaleModel, ModelCollect } = this.state;
        if (key === 'currency') {
            if (value === 'USD' && Number(PaymentSaleModel.TypeMethod) !== 3) {
                this.props.notificationReducer.showAlert({ type: 'warning', message: 'Los pagos en USD solo admiten transferencias.' });
                return;
            }
            if (ModelCollect.PaymentsToSale?.some(payment => ![14, 117].includes(Number(payment.TypeMethod)))) {
                this.props.notificationReducer.showAlert({ type: 'warning', message: 'La moneda es única para todo el cobro. Retira los pagos agregados para cambiarla.' });
                return;
            }
            const rate = this.GetVoucherCurrencyRate(value);
            if (!rate) {
                this.props.notificationReducer.showAlert({ type: 'warning', message: 'La moneda seleccionada no tiene un tipo de cambio válido.' });
                return;
            }
            const currentRate = PaymentSaleModel.ChangeRate_1 || 1;
            const totalOriginal = PaymentSaleModel.totalOriginal ?? Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, '')) * currentRate;
            PaymentSaleModel.totalOriginal = totalOriginal;
            PaymentSaleModel.total = Number((totalOriginal / rate).toFixed(2));
            PaymentSaleModel.ChangeRate_1 = rate;
            ModelCollect.DocCur = CURRENCY === 'SOL' && value === 'PEN' ? CURRENCY : value;
            ModelCollect.ChangeRate = rate;
            ModelCollect.ifChangeRate = ModelCollect.DocCur !== CURRENCY;
            ModelCollect.ChangeRate_1 = rate;
            PaymentSaleModel.ifChangeRate = ModelCollect.ifChangeRate;
            this.RefreshOrder(ModelCollect);
        } else if (key === 'total') {
            const amount = Number(String(value).replace(/,/g, ''));
            const previousAmount = Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, ''));
            // Formatear el campo al perder el foco no debe alterar el monto base.
            if (Number.isFinite(amount) && (amount !== previousAmount || PaymentSaleModel.totalOriginal == null)) {
                PaymentSaleModel.totalOriginal = amount * (PaymentSaleModel.ChangeRate_1 || 1);
            }
        }
        PaymentSaleModel[key] = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    changeCFW = async (event = null, type = 1) => {
        const { PaymentSaleModel } = this.state;
        const value = event?.value ?? event?.nativeEvent?.target?.value ?? null;
        const cfwFields = {
            1: 'transferCFWId',
            2: 'cashCFWId',
            3: 'checkCFWId'
        };
        PaymentSaleModel[cfwFields[type]] = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    render() {
        const { enableSpinner } = this.props;

        const {
            cliente,
            dataInvoice,
            showCollectModalModal,
            checkboxDataTables,
            partners,
            pageTotal,
            ModelCollect,
            series,
            ShowOpenSeriesModal,
            ShowAccountsModal,
            accounts,
            ShowPaymentModal,
            checkItemCreateInfo,
            ShowCheckListModal,
            folio,
            newOrderModel,
            showPaymentModal,
            showAreYouAgreeModal,
            ShowPaymentCreditCardsModal,
            cardList,
            ShowAccountsModalCredit,
            accountsCredit,
            PaymentSaleModel,
            addingPay,
            AvailablePayments,
            BankAccounts,
            DownPayments,
            CreditNotes,
            showInitialCashModal,
            _user,
            sendMailModel,
            showPDFViewer,
            docsToPrint,
            EnableEditButton,
            EditableDocModel,

            showCashCutModal,
            cashCut, objCharge, totalCashCut, TotalAmountSales,
            numSalesCashCut, extraPaymentsCashCut, moneyEntries, moneyOuts,
            lastDaySession,
            printhide,
            CancelFunction,
            ReturnedBlindCut,

            PaymentStatus,

            // Fecha de cancelación
            cancelCurrentDate,
            FlagPayWithSantander,
            searchData,
            listDrivers,
            showCollectDeposits = false,
            writeAccess = false,
            dateInit,
            dateFinal,
            tipoFactura,
            globalCurrency,
            allSN = false,
            showNiubizModal,
            currPayment,
            seriesOptions = [],
            selectedSeries = [],
            transportSeriesOptions = [],
            selectedTransportSeries = [],
            multiplePaymentsSummary = [],
            multiplePerceptions = [],
            isSameSerie = false,
            idWorkShift,
            bankOptions = [],
            CFWOptions = [],
            toleranceInfo = [],
            currencys,
        } = this.state;

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        const { notificationReducer: { showAlert } } = this.props;
        const tipoFacturaOptions = [
            { value: '', label: 'Todos' },
            { value: 1, label: 'Contado' },
            { value: 2, label: 'Crédito' }
        ];

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'COBRANZA'} url1={'#'} />
                <ValidationModal
                    idValidation="vmPayWithTerminal"
                    message="Iniciar proceso de pago con tarjeta?"
                    button1="Si"
                    button2="No"
                    eventOnclick={async () => await this.PayWithCreditTerminal()}
                    eventOnclick2={async () => await this.CancelPayWithTerminal()}
                />
                <VoucherUploadModal
                />
                <div style={{ marginLeft: "4rem" }}>
                    <div>

                        <div className="row m-3">
                            <h3 className="ml-4 mb-2 mt-3">Cobranza</h3>
                        </div>

                        <div style={{ marginTop: 30 }}>
                            <nav>
                                <div className="nav nav-tabs" id="nav-cobranza-tab" role="tablist">

                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active"
                                        id="nav-clientes-tab"
                                        data-toggle="tab"
                                        href="#tabClientes"
                                        role="tab"
                                        aria-controls="tabClientes"
                                        aria-selected="true"
                                    >
                                        Clientes
                                    </a>
                                    {Modules['llgReconciliation'] &&
                                        <a
                                            className="nav-item nav-link font-weight-bold text-secondary"
                                            id="nav-pagos-tab"
                                            data-toggle="tab"
                                            href="#tabPagos"
                                            role="tab"
                                            aria-controls="tabPagos"
                                            aria-selected="false"
                                        >
                                            Pagos
                                        </a>
                                    }
                                </div>
                            </nav>

                            <div className="tab-content" style={{ textAlign: 'left' }}>
                                <div
                                    className="tab-pane active"
                                    id="tabClientes"
                                    role="tabpanel"
                                    aria-labelledby="nav-clientes-tab"
                                >

                                    <div className="row m-3">
                                        <div className="col-xl-12 mb-4 mb-xl-0">
                                            <div className="container-fluid mt-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        {/* <div className={`row ${Modules['oxxoReferences'] ? 'mb-1' : 'mb-4'}`}> */}
                                                        <div className={'row mb-1'}>
                                                            {/* <div className="col-3">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1"><strong>Factura</strong></span>
                                                        </div>
                                                        <input 
                                                            type="text" 
                                                            className="form-control"
                                                            placeholder="N° de documento"
                                                            id="numberSearch" 
                                                            // onKeyUp={()=>this.DoSearch("generalData","numberSearch")}
                                                            onChange={this.ChangeFolio}
                                                            value={folio ? folio : ''}
                                                        />
                                                    </div>
                                                </div> */}

                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <div className="input-group-text d-flex align-items-center">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="todosCheck"
                                                                                checked={allSN || false}
                                                                                onChange={this.handleAllSN}
                                                                                style={{
                                                                                    transform: 'scale(1.4)',
                                                                                    marginRight: '8px',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            />
                                                                            <strong>Todos los clientes</strong>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text" id="basic-addon1"><strong>Cliente</strong></span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Código de cliente"
                                                                        id="clientSearch"
                                                                        onChange={this.ChangeCliente}
                                                                        value={cliente ? cliente : ''}
                                                                        disabled={allSN}
                                                                        onKeyPress={(ev) => {
                                                                            if (ev.key === 'Enter') {
                                                                                this.setState({
                                                                                    isNewSearch: true, selectedSeries: [], seriesOptions: []
                                                                                }, () => {
                                                                                    !allSN && this.CargarDatos();
                                                                                });
                                                                            }
                                                                        }}
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#afafaf', borderLeft: "none" }} onClick={() => this.CargarDatos()}>
                                                                            <i className="fa fa-search" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-auto col-md-auto col-lg-auto text-left mb-2">
                                                                <button className="btn btn-active" onClick={() => this.openPartner()}
                                                                    style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right", marginRight: "1vh" }}>
                                                                    <i className="fa fa-address-book-o"></i>
                                                                </button>
                                                                {/* <button className="btn btn-active" onClick={() => this.CheckTerminalConnection()}
                                                                    style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                                    <i className="fa fa-credit-card-alt"></i>
                                                                </button> */}
                                                            </div>

                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text" id="basic-addon1"><strong>Desde</strong></span>
                                                                    </div>
                                                                    <input id="fechaInicio"
                                                                        className="form-control btn-outline-secondary listSerie " type="date"
                                                                        placeholder="Fecha min" autoComplete="off"
                                                                        max='9999-12-31'
                                                                        value={dateInit}
                                                                        onChange={this.handleChangeFechaInicio}
                                                                        onBlur={this.handleBlurFechaInicio}
                                                                        onKeyDown={event => {
                                                                            if (event.keyCode === 13) {
                                                                                this.handleBlurFechaInicio();
                                                                                this.handleBlurFechaFin();
                                                                                this.CargarDatos();
                                                                            }
                                                                        }} />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text" id="basic-addon1"><strong>Hasta</strong></span>
                                                                    </div>
                                                                    <input id="fechaFin"
                                                                        className="form-control btn-outline-secondary listSerie " type="date"
                                                                        placeholder="Fecha max" autoComplete="off"
                                                                        max='9999-12-31'
                                                                        value={dateFinal}
                                                                        onChange={this.handleChangeFechaFin}
                                                                        onBlur={this.handleBlurFechaFin}
                                                                        onKeyDown={event => {
                                                                            if (event.keyCode === 13) {
                                                                                this.handleBlurFechaInicio();
                                                                                this.handleBlurFechaFin();
                                                                                this.CargarDatos();
                                                                            }
                                                                        }} />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">
                                                                            <strong>Tipo</strong>
                                                                        </span>
                                                                    </div>

                                                                    <Select
                                                                        options={tipoFacturaOptions}
                                                                        value={tipoFacturaOptions.find(
                                                                            option => option.value === tipoFactura
                                                                        )}
                                                                        onChange={(selectedOption) => {
                                                                            const tipoFactura = selectedOption?.value || '';

                                                                            this.setState({
                                                                                tipoFactura,
                                                                                isNewSearch: true,
                                                                                selectedSeries: [],
                                                                                seriesOptions: []
                                                                            }, () => {
                                                                                this.CargarDatos();
                                                                            });
                                                                        }}
                                                                        placeholder="Filtrar por Tipo"
                                                                        isSearchable={false}
                                                                        isClearable={false}
                                                                        menuPortalTarget={document.body}
                                                                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                                        styles={{
                                                                            container: (base) => ({
                                                                                ...base,
                                                                                flex: 1
                                                                            }),
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                height: 40,
                                                                                minHeight: 40,
                                                                                minWidth: 200,
                                                                                borderRadius: 4,
                                                                                backgroundColor: "transparent",
                                                                                borderColor: "#ced4da",
                                                                                borderTopLeftRadius: 0,
                                                                                borderBottomLeftRadius: 0
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                zIndex: 9999
                                                                            }),
                                                                            menuPortal: (base) => ({
                                                                                ...base,
                                                                                zIndex: 9999
                                                                            }),
                                                                            singleValue: (base) => ({
                                                                                ...base,
                                                                                color: "#000"
                                                                            })
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <Select
                                                                        options={seriesOptions}
                                                                        value={selectedSeries}
                                                                        onChange={(selectedOptions) => {
                                                                            const newSelectedSeries = selectedOptions || [];
                                                                            const selectedSeriesValues = newSelectedSeries.map(option => String(option.value));
                                                                            const { dataInvoiceCopy, selectedTransportSeries } = this.state;
                                                                            const selectedTransportSeriesValues = (selectedTransportSeries || []).map(option => String(option.value));
                                                                            const allSelectedSeries = [...selectedSeriesValues, ...selectedTransportSeriesValues];
                                                                            let filteredData = dataInvoiceCopy || [];
                                                                            if (allSelectedSeries.length > 0) {
                                                                                filteredData = (dataInvoiceCopy || []).filter(document => {
                                                                                    const extractedSerie = document.NumAtCard
                                                                                        ? this.extractSerie(document.NumAtCard)
                                                                                        : null;

                                                                                    return (
                                                                                        extractedSerie &&
                                                                                        allSelectedSeries.includes(String(extractedSerie))
                                                                                    );
                                                                                });
                                                                            }

                                                                            this.setState({
                                                                                selectedSeries: newSelectedSeries,
                                                                                dataInvoice: filteredData,
                                                                                isNewSearch: false
                                                                            });
                                                                        }}
                                                                        onBlur={() => {
                                                                            const { selectedSeries } = this.state;

                                                                            if (!selectedSeries || selectedSeries.length === 0) {
                                                                                this.setState({ isNewSearch: true });
                                                                            }
                                                                        }}
                                                                        placeholder="Filtrar por Serie"
                                                                        isMulti={true}
                                                                        isSearchable={true}
                                                                        isClearable={true}
                                                                        menuPortalTarget={document.body}
                                                                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                                        styles={{
                                                                            container: (base) => ({ ...base, flex: 1 }),
                                                                            control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 200, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                            valueContainer: (base) => ({ ...base, maxHeight: 40, overflowY: 'auto', flexWrap: 'wrap' }),
                                                                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                                            singleValue: (base) => ({ ...base, color: "#000" })
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                                <div className="input-group mb-3">
                                                                    <Select
                                                                        options={transportSeriesOptions}
                                                                        value={selectedTransportSeries}
                                                                        onChange={(selectedOptions) => {
                                                                            const newSelectedTransportSeries = selectedOptions || [];
                                                                            const selectedTransportSeriesValues = newSelectedTransportSeries.map(option => String(option.value));
                                                                            const { dataInvoiceCopy, selectedSeries } = this.state;
                                                                            const selectedSeriesValues = (selectedSeries || []).map(option => String(option.value));
                                                                            const allSelectedSeries = [...selectedSeriesValues, ...selectedTransportSeriesValues];
                                                                            let filteredData = dataInvoiceCopy || [];
                                                                            if (allSelectedSeries.length > 0) {
                                                                                filteredData = (dataInvoiceCopy || []).filter(document => {
                                                                                    const extractedSerie = document.NumAtCard ? this.extractSerie(document.NumAtCard) : null;
                                                                                    return (
                                                                                        extractedSerie &&
                                                                                        allSelectedSeries.includes(String(extractedSerie))
                                                                                    );
                                                                                });
                                                                            }
                                                                            this.setState({
                                                                                selectedTransportSeries: newSelectedTransportSeries,
                                                                                dataInvoice: filteredData,
                                                                                isNewSearch: false
                                                                            });
                                                                        }}
                                                                        placeholder="Series del Transporte"
                                                                        isMulti={true}
                                                                        isSearchable={true}
                                                                        isClearable={true}
                                                                        menuPortalTarget={document.body}
                                                                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                                        styles={{
                                                                            container: (base) => ({ ...base, flex: 1 }),
                                                                            control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 200, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                            valueContainer: (base) => ({ ...base, maxHeight: 40, overflowY: 'auto', flexWrap: 'wrap' }),
                                                                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                                            singleValue: (base) => ({ ...base, color: "#000" })
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* <div className="col-12 col-sm-4 col-md-4 col-lg-3 text-right mb-2">
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">
                                                                            <strong>IVA:</strong>
                                                                        </span>
                                                                    </div>
                                                                    <select
                                                                        name="select"
                                                                        className="form-control"
                                                                        onChange={(event) => this.ChangeTaxFilter(event.target.value)}
                                                                    >
                                                                        <option value="0">Todas</option>
                                                                        <option value="20">20 % </option>
                                                                        <option value="19">19 % </option>
                                                                        <option value="18">18 % </option>
                                                                        <option value="16">16 % </option>
                                                                        <option value="8">8 % </option>

                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                            <div className="col-12 col-sm-4 col-md-4 col-lg-3 text-right mb-2 d-none">
                                                                {/* {!!dataInvoice && dataInvoice.length > 0 &&  */}
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Escribe el Nro. de folio a cancelar"
                                                                        id="Nro_Close"
                                                                        onChange={this.ChangeFolio}
                                                                        value={folio ? folio : ''}
                                                                        onKeyPress={(ev) => { if (ev.key === 'Enter') { this.SearchPayment(); } }}
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <button type="button" className="input-group-text" /*data-toggle="modal" data-target="#paymentModal"*/ style={{ backgroundColor: 'transparent', color: '#afafaf', borderLeft: "none" }} onClick={() => this.SearchPayment()}>
                                                                            <i className="fa fa-search" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row mb-4">
                                                            {Modules['oxxoReferences'] &&

                                                                <div className="col-3">
                                                                    <div className="input-group mb-3">
                                                                        <div className="input-group-prepend">
                                                                            <span className="input-group-text" id="basic-addon1"><strong>Ref. Oxxo</strong></span>
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Referencia Oxxo"
                                                                            onChange={(event) => this.ChangeOxxoRefField('OxxoReference', event)}
                                                                            value={this.state.OxxoReference ? this.state.OxxoReference : ''}
                                                                            onKeyDown={(ev) => { if (ev.key === 'Enter') { this.CargarDatos(); } }}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#afafaf', borderLeft: "none" }} onClick={() => this.CargarDatos()}>
                                                                                <i className="fa fa-search" />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            }

                                                            <div className="col-12 col-md-1 text-left">

                                                            </div>

                                                            <div className="col-12 col-md-3 text-right">

                                                            </div>
                                                            <div className="col-12 col-md-3 text-right">

                                                            </div>
                                                            <div className="col-12 col-md-2 text-right">

                                                            </div>
                                                        </div>
                                                        <DataTables
                                                            headers={headers}
                                                            view={"collectView"}
                                                            data={dataInvoice}
                                                            search={this.searchCollectDoc}
                                                            totalRows={dataInvoice?.length}
                                                            ShowCollectModalModal={this.ShowCollectModalModal}
                                                            depositos={this.depositos}
                                                            ref={this.dataTablesRef}
                                                        />
                                                        <div className='card scrollTableCollect'>
                                                            <table className="table table-striped table-hover d-none" id="generalData">
                                                                <thead className='sticky-headerPOS' style={{ backgroundColor: 'white' }}>
                                                                    <tr>
                                                                        <th className="text-center">
                                                                            {/* <input
                                                                    type="checkbox"
                                                                    style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                    id="CheckAllCollet"
                                                                    onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                                /> */}
                                                                        </th>
                                                                        <th className=" text-center" scope="col">
                                                                            Factura
                                                                        </th>
                                                                        {/* <th className=" text-center" scope="col">
                                                                            Folio Counter
                                                                        </th> */}
                                                                        <th className=" text-center" scope="col">
                                                                            No.Ref.de. cliente
                                                                        </th>
                                                                        {/* <th className=" text-center" scope="col">
                                                                            PUE/PPD
                                                                        </th> */}
                                                                        {/* <th className=" text-center" scope="col">
                                                                            TaxPrcnt
                                                                        </th> */}
                                                                        <th className="text-center" scope="col">
                                                                            Cliente
                                                                        </th>
                                                                        <th className="text-center" scope="col">
                                                                            Nombre
                                                                        </th>
                                                                        <th className="text-center" scope="col">
                                                                            Fecha
                                                                        </th>
                                                                        <th className="text-center" scope="col">
                                                                            Venció
                                                                        </th>
                                                                        <th className="text-center" scope="col">
                                                                            Total
                                                                        </th>
                                                                        <th className="text-center" scope="col">
                                                                            Abonado
                                                                        </th>
                                                                        <th className="text-center" scope="col">
                                                                            Por pagar
                                                                        </th>
                                                                        {Modules['oxxoReferences'] &&
                                                                            <th className="text-center" scope="col">
                                                                                Oxxo
                                                                            </th>
                                                                        }

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {!!dataInvoice && dataInvoice.map((invoice, index) => {
                                                                        return (
                                                                            <tr key={index} style={{ whiteSpace: 'nowrap' }}>
                                                                                <td className="text-center">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                                        id="CheckAll"
                                                                                        checked={!!checkbox.data.get(index)}
                                                                                        onChange={() => checkbox.selectOne(index)}
                                                                                    />
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <strong>{invoice.DocNum}</strong>
                                                                                </td>
                                                                                {/* Folio Counter */}
                                                                                {/* <td className="text-center">

                                                                                    <strong>{invoice.U_FMB_FolioCounter ?? ''}</strong>
                                                                                </td> */}
                                                                                {/* No.Ref.de. cliente */}
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                                                    <strong>{invoice.NumAtCard}</strong>
                                                                                </td>
                                                                                {/* <td className="text-center">
                                                                                    <strong>{invoice?.U_SO1_02METODOPAGO ?? ''}</strong>
                                                                                </td> */}
                                                                                {/* <td className="text-center">
                                                                                    <strong>{`${invoice?.PrcntTax} %` ?? ''}</strong>
                                                                                </td> */}
                                                                                <td className="text-center">{invoice.CardCode ?? ''}</td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{invoice.U_FMB_AUX_CARDNAME || invoice.CardName || ''}</td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{!invoice.DocDate ? '' : moment(invoice.DocDate).utc().format('YYYY-MM-DD')}</td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{!invoice.DocDueDate ? '' : moment(invoice.DocDueDate).utc().format('YYYY-MM-DD')}</td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{`${invoice.DocCur} ${formatNumber.new(invoice.DocTotal)}`}</td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{`${invoice.DocCur} ${formatNumber.new(invoice.DocTotal - invoice.PorVencer)}`}</td>
                                                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{`${invoice.DocCur} ${formatNumber.new(invoice.PorVencer)}`}</td>
                                                                                {Modules['oxxoReferences'] &&
                                                                                    <td className="text-center">{invoice?.Reference ?? ''}</td>
                                                                                }
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                    <tr className='noSearch hide'>
                                                                        <td colSpan="9"></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="tabPagos"
                                    role="tabpanel"
                                    aria-labelledby="nav-pagos-tab"
                                >
                                    <div className="row m-3">
                                        <div className="col-md-12">
                                            <FactoryActions
                                                props={{ ...this.props, view: 'AccountsReceivable' }}
                                                state={this.state}
                                                searchData={searchData}
                                                refreshSearch={this.refreshSearch}
                                                listDrivers={listDrivers}
                                                search={this.searchPayments}
                                            />
                                            <FactoryHeader
                                                props={{ ...this.props, view: 'AccountsReceivable' }}

                                            />
                                            <FactoryBody
                                                props={{ ...this.props, view: 'AccountsReceivable' }}
                                            />

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                {showCollectModalModal && (
                    <CollectModal
                        ShowCollectModalModal={this.ShowCollectModalModal}
                        ModelCollect={ModelCollect}
                        SelectDocDate={this.SelectDocDate}
                        SelectDocDueDate={this.SelectDocDueDate}
                        ChangeTotalInvoicePayment={this.ChangeTotalInvoicePayment}
                        ValidateTotalInvoicePaymentNull={this.ValidateTotalInvoicePaymentNull}

                        OpenSeries={this.OpenSeries}
                        ShowOpenSeriesModal={ShowOpenSeriesModal}
                        series={series}
                        SelectSeries={this.SelectSeries}
                        cleanDataSeries={() => this.setState({ series: [] })}

                        OpenCuentaMayor={this.OpenCuentaMayor}
                        ShowAccountsModal={ShowAccountsModal}
                        accounts={accounts}
                        SelectAccountList={this.SelectAccountList}
                        cleanDataAccounts={() => this.setState({ accounts: [], ShowAccountsModal: false })}

                        changeCashSumEnter={this.changeCashSumEnter}
                        changeCashSum={this.changeCashSum}
                        validateCashSumNull={this.validateCashSumNull}
                        Abonar={this.Abonar}
                        ShowPaymentModal={ShowPaymentModal}
                        changeTrsfrSum={this.changeTrsfrSum}
                        validateTrsfrSumNull={this.validateTrsfrSumNull}
                        openCheckList={this.openCheckList}
                        Continue={this.Continue}
                        checkItemCreateInfo={checkItemCreateInfo}
                        ShowCheckListModal={ShowCheckListModal}
                        refreshTotal={this.refreshTotal}
                        addNewItemCheck={this.addNewItemCheck}
                        deleteItemCheck={this.deleteItemCheck}

                        changeAccountCashAcct={this.changeAccountCashAcct}
                        changeAccountCheck={this.changeAccountCheck}
                        changeAccountTrsfr={this.changeAccountTrsfr}
                        ShowPaymentCreditCardsModal={ShowPaymentCreditCardsModal}
                        OpenPaymentCreditCards={this.OpenPaymentCreditCards}
                        ClosePaymentCreditCardsModal={this.ClosePaymentCreditCardsModal}
                        refreshModel={this.refreshModel}
                        selectTabCard={this.selectTabCard}
                        addCreditCard={this.addCreditCard}
                        deleteCard={this.deleteCard}
                        openCard={this.openCard}
                        cardList={cardList}
                        validateCardNum={this.validateCardNum}
                        changeCardNum={this.changeCardNum}
                        changeCardValid={this.changeCardValid}
                        changeValidateValidCard={this.changeValidateValidCard}
                        changeOwnerIdNum={this.changeOwnerIdNum}
                        changeOwnerPhone={this.changeOwnerPhone}
                        keydownHandler={this.keydownHandler}
                        changeCreditSum={this.changeCreditSum}
                        changeTransfersRef={this.changeTransfersRef}
                        changeVoucherNum={this.changeVoucherNum}
                        changeCreditType={this.changeCreditType}
                        changeCreditSumOne={this.changeCreditSumOne}
                        selectCardList={this.selectCardList}
                        cleanCardList={() => this.setState({ cardList: [] })}

                        OpenCuentaMayorCredit={this.OpenCuentaMayorCredit}
                        ShowAccountsModalCredit={ShowAccountsModalCredit}
                        accountsCredit={accountsCredit}
                        SelectAccountListCredit={this.SelectAccountListCredit}
                        cleanDataAccountsCredit={() => this.setState({ accountsCredit: [], ShowAccountsModalCredit: false })}

                        AplicarPago={this.AplicarPago}
                        // showAlert={showAlert}
                        // showBillModal={showBillModal}
                        enableSpinner={enableSpinner}
                        PaymentSaleModel={PaymentSaleModel}
                        addingPay={addingPay}
                        AvailablePayments={AvailablePayments}
                        BankAccounts={BankAccounts}
                        DownPayments={DownPayments}
                        CreditNotes={CreditNotes}

                        AddPay={this.AddPay}
                        findInName={this.findInName}
                        ChangeTypePayMethod={this.ChangeTypePayMethod}
                        DoSearch_1={this.DoSearch_1}

                        ChangePaycheckNum={this.ChangePaycheckNum}
                        ChangeDatePayCheck={this.ChangeDatePayCheck}
                        ChangeBank={this.ChangeBank}
                        ChangeCardNum={this.ChangeCardNum}
                        ChangeVoucherNum={this.ChangeVoucherNum}
                        ChangeIndentification={this.ChangeIndentification}
                        ChangePhoneNum={this.ChangePhoneNum}
                        ChangeValidCard={this.ChangeValidCard}
                        ChangeValidateValidCard={this.ChangeValidateValidCard}
                        ChangeTransferNum={this.ChangeTransferNum}
                        ChangePayAccountNum={this.ChangePayAccountNum}
                        ChangeReturnFolio={this.ChangeReturnFolio}
                        ChangeDocEntryDP={this.ChangeDocEntryDP}
                        ChangeDocEntryCN={this.ChangeDocEntryCN}
                        ChangeAmount={this.ChangeAmount}
                        addingPaymentSale={this.addingPaymentSale}
                        RemovePaymentSale={this.RemovePaymentSale}
                        ChangeParcialidadInvoicePayment={this.ChangeParcialidadInvoicePayment}
                        FlagPayWithSantander={FlagPayWithSantander}
                        formatNumber={formatNumber}
                        SelectU_BPP_PTSCPaymentDefault={this.SelectU_BPP_PTSCPaymentDefault}
                        allSN={allSN}
                        showNiubizModal={showNiubizModal}
                        currPayment={currPayment}
                        globalCurrency={globalCurrency}
                        onChangeVoucher={this.onChangeVoucher}
                        validateVoucher={this.validateVoucher}
                        bankOptions={bankOptions}
                        RemovePaymentSaleByNiubiz={this.RemovePaymentSaleByNiubiz}
                        addNiubizReference={this.addNiubizReference}
                        showAlert={showAlert}
                        changeCFW={this.changeCFW}
                        currencys={currencys}
                    />
                )}

                {partners.length > 0 &&
                    <PartnerCreateModal
                        data={partners}
                        type={'C'}
                        totalPage={pageTotal}
                        selectPartner={this.SelectPartner}
                        cleanData={() => this.setState({ partners: [] })}
                        refreshPartner={this.RefreshPartner}
                    />
                }

                {showPaymentModal > 0 &&
                    <PaymentModal
                        newOrderModel={newOrderModel}
                        CancelPayment={this.CancelPaymentSAP}
                        CloseModalPayment={this.CloseModalPayment}
                        showAreYouAgreeModal={showAreYouAgreeModal}
                        OpenShowAreYouAgreeModal={this.ValidateCancelDate}
                        CloseShowAreYouAgreeModal={this.CloseShowAreYouAgreeModal}
                        ConsultarEstatusPagoCFDI={this.ConsultarEstatusPagoCFDI}
                        CancelCFDI={this.ShowCancelConfirm}
                    />
                }

                {PaymentStatus.length > 0 &&
                    <PaymentStatusListModal
                        data={PaymentStatus}
                        SearchPayment={() => { }}
                        CancelRelatedCFDI={() => { }}
                        ContinueToCancel={() => { }}
                        CancelPayments={() => { }}
                        cleanData={() => { }}
                    />
                }

                <CancelPaymentModal
                    cancelCurrentDate={cancelCurrentDate}
                    changeCancelDate={this.changeCancelDate}
                    continueAction={this.OpenShowAreYouAgreeModal}
                    changeCancelMode={this.changeCancelMode}
                    changeDocumentDate={this.changeDocumentDate}
                    resetPaymentsToCancel={this.resetPaymentsToCancel}
                />

                {showInitialCashModal && (
                    <InitialCashModal
                        InsertWorkShiftT={this.InsertWorkShiftT}
                        CancelWorkShift={this.CancelWorkShift}
                    />
                )}

                {showPDFViewer && (
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={'ORCT'}
                        EnableEditButton={EnableEditButton}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditableDocModel={EditableDocModel}
                        RefreshDocModel={this.RefreshDocModel}
                        SaveChanges={this.SaveChangesInvoice}
                        UploadDoc={this.UploadInvoice}
                        EditParam1={false}
                        ShowPDFViewer={this.CloseCreatedInvoiceActions}
                        CreateDocument={this.CreateDocument}
                        OpenMailModal={this.OpenSendMailModal}
                        ItsFirme={true}
                        user={_user}
                        Counter={true}
                        MailTools={mailTools}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                )}

                {showCashCutModal && (
                    <CashCutModal
                        ShowCashCutModal={this.ShowCashCutModal}
                        CashCut={cashCut}
                        ObjCharge={objCharge}
                        TotalCashCut={totalCashCut}
                        TotalAmountSales={TotalAmountSales}
                        NumVentas={numSalesCashCut}
                        extraPaymentsCashCut={extraPaymentsCashCut}
                        moneyEntries={moneyEntries}
                        moneyOuts={moneyOuts}
                        headerCashCut={{ U_NAME: "", docUpdate: "", endSession: "" }}
                        BranchOfficeGeneralCut={() => { }}
                        CloseWorkShift={this.CloseWorkShift}
                        GotoDashboard={this.SendToLogin}
                        lastDaySession={lastDaySession}
                        _user={_user}
                        blindCashCut={true}
                        ReturnedBlindCut={ReturnedBlindCut}
                        BlindCutByIdSession={[]}
                        bankOptions={bankOptions}
                    />
                )}

                {showCollectDeposits && (
                    <CollectDeposits
                        cancel={this.depositos}
                        cancelAndSearch={this.depositos}
                        ModelCollect={ModelCollect}
                        writeAccess={writeAccess}
                        globalCurrency={globalCurrency}
                        idSession={idWorkShift}
                        bankOptions={bankOptions}
                        CFWOptions={CFWOptions}
                        toleranceInfo={toleranceInfo}
                    />
                )}

                <CancelCFDI
                    CancelDocuments={CancelFunction} />

                <div id="multiplePaymentsSummaryModal" className="modal fade bd-example-modal-lg bgtransparent" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Resumen de Pagos
                                </h5>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover text-center" style={{ width: '100%', maxHeight: 600, overflow: "auto" }}>
                                        <thead className="table-header-yellow">
                                            <tr>
                                                <th>Cliente</th>
                                                <th>N° Pago</th>
                                                <th>Folio</th>
                                                <th>Estado</th>
                                                <th>Mensaje</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(multiplePaymentsSummary || [])?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4">Sin información</td>
                                                </tr>
                                            ) : (
                                                multiplePaymentsSummary?.map((row, index) => (
                                                    <tr key={index}>
                                                        <td style={{ whiteSpace: 'nowrap' }}>{row.cardCode ?? ''}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>{row.paymentDocNum ?? ''}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>{row.folio ?? ''}</td>
                                                        <td>
                                                            <span
                                                                className={`badge ${row.status === "success"
                                                                    ? "badge-success"
                                                                    : "badge-danger"
                                                                    }`}
                                                            >
                                                                {row.status === "success"
                                                                    ? "Procesado"
                                                                    : "No procesado"}
                                                            </span>
                                                        </td>
                                                        <td>{row.paymentMessage ?? ''}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={this.closeMultiplePaymentsSummary} className="btn btn-secondary"> Cerrar </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="multiplePerceptionsModal" className="modal fade bd-example-modal-lg bgtransparent" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md modal-open" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Percepciones</h5>
                            </div>
                            <div className="modal-body">
                                <>
                                    <strong>Por favor, indique la serie del comprobante de percepción para cada cliente.</strong>
                                    {multiplePerceptions?.length > 1 &&
                                        <div className="col-12 p-0 my-2 input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text font-weight-bold">
                                                    <input
                                                        type="checkbox"
                                                        style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                        id={`checkSameSerie`}
                                                        checked={isSameSerie}
                                                        onChange={this.handleIsSameSerie}
                                                    />
                                                </div>
                                            </div>
                                            <input
                                                className="form-control"
                                                id={`inputSameSerie`}
                                                value={'Misma Serie del documento'}
                                                readOnly
                                            />
                                        </div>
                                    }
                                    <div className="table-responsive">
                                        <table className="display mt-2" style={{ width: '100%', maxHeight: 600, overflow: "auto" }}>
                                            <thead className="table-header-yellow">
                                                <tr style={{ textAlign: "center" }}>
                                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                        Cliente
                                                    </td>
                                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                        Tipo de Documento
                                                    </td>
                                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                        Serie del documento
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {multiplePerceptions?.map((row, index) => (
                                                    <tr key={`${row.voucherNumber}-${index}`}>
                                                        <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{row.cardCode}</td>
                                                        <td className="text-center">{row.U_BPP_MDTDPaymentDefault}</td>
                                                        <td className="text-center" style={{ width: '120px' }}>
                                                            <input
                                                                type="text"
                                                                value={row.U_BPP_PTSCPaymentDefault || ''}
                                                                maxLength={4}
                                                                className="form-control"
                                                                disabled={isSameSerie && index !== 0}
                                                                onChange={({ target: { value } }) => this.handleSerieChange(value, index)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={() => { this.handleConfirmPerceptions(); }} className={`btn btn-${multiplePerceptions?.some(row => !row.U_BPP_PTSCPaymentDefault) ? "dark" : "warning"}`} disabled={multiplePerceptions?.some(row => !row.U_BPP_PTSCPaymentDefault)}> Continuar </button>
                                <button type="button" onClick={this.goBackPerceptions} className="btn btn-secondary"> Volver </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CollectView);
